export enum EPaises {
	AFGANISTAN = '004',
	ALAND_ISLAS = '248',
	ALBANIA = '008',
	ALEMANIA = '276',
	ANDORRA = '020',
	ANGOLA = '024',
	ANGUILA = '660',
	ANTARTIDA = '010',
	ANTIGUA_Y_BARBUDA = '028',
	ARABIA_SAUDITA = '682',
	ARGELIA = '012',
	ARGENTINA = '032',
	ARMENIA = '051',
	ARUBA = '533',
	AUSTRALIA = '036',
	AUSTRIA = '040',
	AZERBAIYAN = '031',
	BAHAMAS = '044',
	BAHREIN = '048',
	BANGLADESH = '050',
	BARBADOS = '052',
	BELARUS = '112',
	BELGICA = '056',
	BELICE = '084',
	BENIN = '204',
	BERMUDAS = '060',
	BHUTAN = '064',
	BOLIVIA = '068',
	BONAIRE_SAN_EUSTAQUIO_Y_SABA = '535',
	BOSNIA_Y_HERZEGOVINA = '070',
	BOTSWANA = '072',
	BOUVET_ISLA = '074',
	BRASIL = '076',
	BRUNEI_DARUSSALAM = '096',
	BULGARIA = '100',
	BURKINA_FASO = '854',
	BURUNDI = '108',
	CABO_VERDE = '132',
	CAIMAN_ISLAS = '136',
	CAMBOYA = '116',
	CAMERUN = '120',
	CANADA = '124',
	CHAD = '148',
	CHILE = '152',
	CHINA = '156',
	CHIPRE = '196',
	COCOS_KEELING_ISLAS = '166',
	COLOMBIA = '170',
	COMORAS = '174',
	CONGO = '178',
	CONGO_REPUBLICA_DEMOCRATICA = '180',
	COOK_ISLAS = '184',
	COREA_DEL_SUR = '410',
	COREA_DEL_NORTE = '408',
	COSTA_RICA = '188',
	COSTA_DE_MARFIL = '384',
	CROACIA = '191',
	CUBA = '192',
	CURACAO = '531',
	DINAMARCA = '208',
	DJIBOUTI = '262',
	DOMINICA = '212',
	REPUBLICA_DOMINICANA = '214',
	ECUADOR = '218',
	EGIPTO = '818',
	EL_SALVADOR = '222',
	EMIRATOS_ARABES_UNIDOS = '784',
	ERITREA = '232',
	ESLOVAQUIA = '703',
	ESLOVENIA = '705',
	ESPANA = '724',
	ESTADOS_UNIDOS = '840',
	ESTONIA = '233',
	ETIOPIA = '231',
	FEROE_ISLAS = '234',
	FIJI = '242',
	FILIPINAS = '608',
	FINLANDIA = '246',
	FRANCIA = '250',
	GABON = '266',
	GAMBIA = '270',
	GEORGIA = '268',
	GHANA = '288',
	GIBRALTAR = '292',
	GRANADA = '308',
	GRECIA = '300',
	GROENLANDIA = '304',
	GUADALUPE = '312',
	GUAM = '316',
	GUATEMALA = '320',
	GUAYANA_FRANCESA = '254',
	GUERNSEY = '831',
	GUINEA = '324',
	GUINEA_BISSAU = '624',
	GUINEA_ECUATORIAL = '226',
	GUYANA = '328',
	HAITI = '332',
	HONDURAS = '340',
	HONG_KONG = '344',
	HUNGRIA = '348',
	INDIA = '356',
	INDONESIA = '360',
	IRAN = '364',
	IRAQ = '368',
	IRLANDA = '372',
	ISLA_DE_MAN = '833',
	ISLANDIA = '352',
	ISRAEL = '376',
	ITALIA = '380',
	JAMAICA = '388',
	JAPON = '392',
	JERSEY = '832',
	JORDANIA = '400',
	KAZAJSTAN = '398',
	KENIA = '404',
	KIRGUISTAN = '417',
	KIRIBATI = '296',
	KUWAIT = '414',
	LAOS = '418',
	LESOTO = '426',
	LETONIA = '428',
	LIBANO = '422',
	LIBERIA = '430',
	LIBIA = '434',
	LIECHTENSTEIN = '438',
	LITUANIA = '440',
	LUXEMBURGO = '442',
	MACAO = '446',
	MACEDONIA = '807',
	MADAGASCAR = '450',
	MALASIA = '458',
	MALAWI = '454',
	MALDIVAS = '462',
	MALI = '466',
	MALTA = '470',
	MALVINAS = '238',
	MARIANAS_DEL_NORTE = '580',
	MARRUECOS = '504',
	MARSHALL_ISLAS = '584',
	MARTINICA = '474',
	MAURICIO = '480',
	MAURITANIA = '478',
	MAYOTTE = '175',
	MEXICO = '484',
	MICRONESIA = '583',
	MOLDAVIA = '498',
	MONACO = '492',
	MONGOLIA = '496',
	MONTENEGRO = '499',
	MONTSERRAT = '500',
	MOZAMBIQUE = '508',
	MYANMAR = '104',
	NAMIBIA = '516',
	NAURU = '520',
	NEPAL = '524',
	NICARAGUA = '558',
	NIGER = '562',
	NIGERIA = '566',
	NORUEGA = '578',
	NUEVA_CALEDONIA = '540',
	NUEVA_ZELANDIA = '554',
	OMAN = '512',
	PAISES_BAJOS = '528',
	PAKISTAN = '586',
	PALAU = '585',
	PALESTINA = '275',
	PANAMA = '591',
	PAPUA_NUEVA_GUINEA = '598',
	PARAGUAY = '600',
	PERU = '604',
	POLINESIA_FRANCESA = '258',
	POLONIA = '616',
	PORTUGAL = '620',
	PUERTO_RICO = '630',
	QATAR = '634',
	REINO_UNIDO = '826',
	SIRIA = '760',
	REPUBLICA_CENTROAFRICANA = '140',
	REPUBLICA_CHECA = '203',
	REUNION = '638',
	RUMANIA = '642',
	RUSIA = '643',
	RWANDA = '646',
	SAHARA_OCCIDENTAL = '732',
	SAN_BARTOLOME = '652',
	SAINT_KITTS_Y_NEVIS = '659',
	SAINT_MARTIN = '663',
	ISLAS_SALOMON = '090',
	SAMOA = '882',
	SAMOA_AMERICANA = '016',
	SAN_MARINO = '674',
	SAN_PEDRO_Y_MIQUELON = '666',
	SAN_VICENTE_Y_LAS_GRANADINAS = '670',
	SANTA_HELENA = '654',
	SANTA_LUCIA = '662',
	SANTA_SEDE = '336',
	SANTO_TOME_Y_PRINCIPE = '678',
	SENEGAL = '686',
	SERBIA = '688',
	SEYCHELLES = '690',
	SIERRA_LEONA = '694',
	SINGAPUR = '702',
	SINT_MAARTEN = '534',
	SOMALIA = '706',
	SRI_LANKA = '144',
	SUDAFRICA = '710',
	SUDAN = '729',
	SUDAN_DEL_SUR = '728',
	SUECIA = '752',
	SUIZA = '756',
	SURINAME = '740',
	TAILANDIA = '764',
	TAIWAN = '158',
	TANZANIA = '834',
	TAYIKISTAN = '762',
	TIMOR_LESTE = '626',
	TOGO = '768',
	TOKELAU = '772',
	TONGA = '776',
	TRINIDAD_Y_TOBAGO = '780',
	TUNEZ = '788',
	TURCAS_Y_CAICOS = '796',
	TURKMENISTAN = '795',
	TURQUIA = '792',
	TUVALU = '798',
	UCRANIA = '804',
	UGANDA = '800',
	URUGUAY = '858',
	UZBEKISTAN = '860',
	VANUATU = '548',
	VENEZUELA = '862',
	VIETNAM = '704',
	VIRGENES_BRITANICAS = '092',
	VIRGENES_ESTADOS_UNIDOS = '850',
	WALLIS_Y_FUTUNA = '876',
	YEMEN = '887',
	ZAMBIA = '894',
	ZIMBABWE = '716',
	POR_DEFINIR = '895',
	VATICANO = '896',
	COSTA_DE_MARFIL_ALT = '897',
	GEORGIA_DEL_SUR_Y_SANDWICH_DEL_SUR = '239',
	HEARD_E_ISLAS_MCDONALD = '334',
	ISLAS_ULTRAMARINAS_MENORES_DE_ESTADOS_UNIDOS = '581',
	ISLA_DE_NAVIDAD = '162',
	NIUE = '570',
	ISLA_NORFOLK = '574',
	PITCAIRN = '612',
	SVALBARD_Y_JAN_MAYEN = '744',
	SWAZILANDIA = '748', // o ESUATINI
	TERRITORIO_BRITANICO_DEL_OCEANO_INDICO = '086',
	TIERRAS_AUSTRALES_FRANCESAS = '260'
}
export const NOMBRE_PAIS: Record<EPaises, string> = {
	[EPaises.AFGANISTAN]: 'AFGANISTÁN',
	[EPaises.ALAND_ISLAS]: 'ALAND, ISLAS',
	[EPaises.ALBANIA]: 'ALBANIA',
	[EPaises.ALEMANIA]: 'ALEMANIA',
	[EPaises.ANDORRA]: 'ANDORRA',
	[EPaises.ANGOLA]: 'ANGOLA',
	[EPaises.ANGUILA]: 'ANGUILA',
	[EPaises.ANTARTIDA]: 'ANTÁRTIDA',
	[EPaises.ANTIGUA_Y_BARBUDA]: 'ANTIGUA Y BARBUDA',
	[EPaises.ARABIA_SAUDITA]: 'ARABIA SAUDITA',
	[EPaises.ARGELIA]: 'ARGELIA',
	[EPaises.ARGENTINA]: 'ARGENTINA',
	[EPaises.ARMENIA]: 'ARMENIA',
	[EPaises.ARUBA]: 'ARUBA',
	[EPaises.AUSTRALIA]: 'AUSTRALIA',
	[EPaises.AUSTRIA]: 'AUSTRIA',
	[EPaises.AZERBAIYAN]: 'AZERBAIYÁN',
	[EPaises.BAHAMAS]: 'BAHAMAS',
	[EPaises.BAHREIN]: 'BAHREÍN',
	[EPaises.BANGLADESH]: 'BANGLADESH',
	[EPaises.BARBADOS]: 'BARBADOS',
	[EPaises.BELARUS]: 'BELARUS',
	[EPaises.BELGICA]: 'BÉLGICA',
	[EPaises.BELICE]: 'BELICE',
	[EPaises.BENIN]: 'BENÍN',
	[EPaises.BERMUDAS]: 'BERMUDAS',
	[EPaises.BHUTAN]: 'BHUTAN',
	[EPaises.BOLIVIA]: 'BOLIVIA',
	[EPaises.BONAIRE_SAN_EUSTAQUIO_Y_SABA]: 'BONAIRE SAN EUSTAQUIO Y SABA',
	[EPaises.BOSNIA_Y_HERZEGOVINA]: 'BOSNIA Y HERZEGOVINA',
	[EPaises.BOTSWANA]: 'BOTSWANA',
	[EPaises.BOUVET_ISLA]: 'BOUVET ISLA',
	[EPaises.BRASIL]: 'BRASIL',
	[EPaises.BRUNEI_DARUSSALAM]: 'BRUNEI DARUSSALAM',
	[EPaises.BULGARIA]: 'BULGARIA',
	[EPaises.BURKINA_FASO]: 'BURKINA FASO',
	[EPaises.BURUNDI]: 'BURUNDI',
	[EPaises.CABO_VERDE]: 'CABO VERDE',
	[EPaises.CAIMAN_ISLAS]: 'CAIMÁN, ISLAS',
	[EPaises.CAMBOYA]: 'CAMBOYA',
	[EPaises.CAMERUN]: 'CAMERÚN',
	[EPaises.CANADA]: 'CANADÁ',
	[EPaises.CHAD]: 'CHAD',
	[EPaises.CHILE]: 'CHILE',
	[EPaises.CHINA]: 'CHINA',
	[EPaises.CHIPRE]: 'CHIPRE',
	[EPaises.COCOS_KEELING_ISLAS]: 'COCOS KEELING ISLAS',
	[EPaises.COLOMBIA]: 'COLOMBIA',
	[EPaises.COMORAS]: 'COMORAS',
	[EPaises.CONGO]: 'CONGO',
	[EPaises.CONGO_REPUBLICA_DEMOCRATICA]: 'CONGO REPÚBLICA DEMOCRÁTICA',
	[EPaises.COOK_ISLAS]: 'COOK ISLAS',
	[EPaises.COREA_DEL_SUR]: 'COREA DEL SUR',
	[EPaises.COREA_DEL_NORTE]: 'COREA DEL NORTE',
	[EPaises.COSTA_RICA]: 'COSTA RICA',
	[EPaises.COSTA_DE_MARFIL]: 'COSTA DE MARFIL',
	[EPaises.CROACIA]: 'CROACIA',
	[EPaises.CUBA]: 'CUBA',
	[EPaises.CURACAO]: 'CURAÇAO',
	[EPaises.DINAMARCA]: 'DINAMARCA',
	[EPaises.DJIBOUTI]: 'DJIBOUTI',
	[EPaises.DOMINICA]: 'DOMINICA',
	[EPaises.REPUBLICA_DOMINICANA]: 'REPÚBLICA DOMINICANA',
	[EPaises.ECUADOR]: 'ECUADOR',
	[EPaises.EGIPTO]: 'EGIPTO',
	[EPaises.EL_SALVADOR]: 'EL SALVADOR',
	[EPaises.EMIRATOS_ARABES_UNIDOS]: 'EMIRATOS ÁRABES UNIDOS',
	[EPaises.ERITREA]: 'ERITREA',
	[EPaises.ESLOVAQUIA]: 'ESLOVAQUIA',
	[EPaises.ESLOVENIA]: 'ESLOVENIA',
	[EPaises.ESPANA]: 'ESPAÑA',
	[EPaises.ESTADOS_UNIDOS]: 'ESTADOS UNIDOS',
	[EPaises.ESTONIA]: 'ESTONIA',
	[EPaises.ETIOPIA]: 'ETIOPÍA',
	[EPaises.FEROE_ISLAS]: 'FEROÉ, ISLAS',
	[EPaises.FIJI]: 'FIJI',
	[EPaises.FILIPINAS]: 'FILIPINAS',
	[EPaises.FINLANDIA]: 'FINLANDIA',
	[EPaises.FRANCIA]: 'FRANCIA',
	[EPaises.GABON]: 'GABÓN',
	[EPaises.GAMBIA]: 'GAMBIA',
	[EPaises.GEORGIA]: 'GEORGIA',
	[EPaises.GHANA]: 'GHANA',
	[EPaises.GIBRALTAR]: 'GIBRALTAR',
	[EPaises.GRANADA]: 'GRANADA',
	[EPaises.GRECIA]: 'GRECIA',
	[EPaises.GROENLANDIA]: 'GROENLANDIA',
	[EPaises.GUADALUPE]: 'GUADALUPE',
	[EPaises.GUAM]: 'GUAM',
	[EPaises.GUATEMALA]: 'GUATEMALA',
	[EPaises.GUAYANA_FRANCESA]: 'GUAYANA FRANCESA',
	[EPaises.GUERNSEY]: 'GUERNSEY',
	[EPaises.GUINEA]: 'GUINEA',
	[EPaises.GUINEA_BISSAU]: 'GUINEA BISSAU',
	[EPaises.GUINEA_ECUATORIAL]: 'GUINEA ECUATORIAL',
	[EPaises.GUYANA]: 'GUYANA',
	[EPaises.HAITI]: 'HAITÍ',
	[EPaises.HONDURAS]: 'HONDURAS',
	[EPaises.HONG_KONG]: 'HONG KONG',
	[EPaises.HUNGRIA]: 'HUNGRÍA',
	[EPaises.INDIA]: 'INDIA',
	[EPaises.INDONESIA]: 'INDONESIA',
	[EPaises.IRAN]: 'IRÁN',
	[EPaises.IRAQ]: 'IRAQ',
	[EPaises.IRLANDA]: 'IRLANDA',
	[EPaises.ISLA_DE_MAN]: 'ISLA DE MAN',
	[EPaises.ISLANDIA]: 'ISLANDIA',
	[EPaises.ISRAEL]: 'ISRAEL',
	[EPaises.ITALIA]: 'ITALIA',
	[EPaises.JAMAICA]: 'JAMAICA',
	[EPaises.JAPON]: 'JAPÓN',
	[EPaises.JERSEY]: 'JERSEY',
	[EPaises.JORDANIA]: 'JORDANIA',
	[EPaises.KAZAJSTAN]: 'KAZAJSTÁN',
	[EPaises.KENIA]: 'KENIA',
	[EPaises.KIRGUISTAN]: 'KIRGUISTÁN',
	[EPaises.KIRIBATI]: 'KIRIBATI',
	[EPaises.KUWAIT]: 'KUWAIT',
	[EPaises.LAOS]: 'LAOS',
	[EPaises.LESOTO]: 'LESOTO',
	[EPaises.LETONIA]: 'LETONIA',
	[EPaises.LIBANO]: 'LÍBANO',
	[EPaises.LIBERIA]: 'LIBERIA',
	[EPaises.LIBIA]: 'LIBIA',
	[EPaises.LIECHTENSTEIN]: 'LIECHTENSTEIN',
	[EPaises.LITUANIA]: 'LITUANIA',
	[EPaises.LUXEMBURGO]: 'LUXEMBURGO',
	[EPaises.MACAO]: 'MACAO',
	[EPaises.MACEDONIA]: 'MACEDONIA',
	[EPaises.MADAGASCAR]: 'MADAGASCAR',
	[EPaises.MALASIA]: 'MALASIA',
	[EPaises.MALAWI]: 'MALAWI',
	[EPaises.MALDIVAS]: 'MALDIVAS',
	[EPaises.MALI]: 'MALI',
	[EPaises.MALTA]: 'MALTA',
	[EPaises.MALVINAS]: 'MALVINAS',
	[EPaises.MARIANAS_DEL_NORTE]: 'MARIANAS DEL NORTE',
	[EPaises.MARRUECOS]: 'MARRUECOS',
	[EPaises.MARSHALL_ISLAS]: 'MARSHALL ISLAS',
	[EPaises.MARTINICA]: 'MARTINICA',
	[EPaises.MAURICIO]: 'MAURICIO',
	[EPaises.MAURITANIA]: 'MAURITANIA',
	[EPaises.MAYOTTE]: 'MAYOTTE',
	[EPaises.MEXICO]: 'MÉXICO',
	[EPaises.MICRONESIA]: 'MICRONESIA',
	[EPaises.MOLDAVIA]: 'MOLDAVIA',
	[EPaises.MONACO]: 'MÓNACO',
	[EPaises.MONGOLIA]: 'MONGOLIA',
	[EPaises.MONTSERRAT]: 'MONTSERRAT',
	[EPaises.MOZAMBIQUE]: 'MOZAMBIQUE',
	[EPaises.MYANMAR]: 'MYANMAR',
	[EPaises.NAMIBIA]: 'NAMIBIA',
	[EPaises.NAURU]: 'NAURU',
	[EPaises.NEPAL]: 'NEPAL',
	[EPaises.NICARAGUA]: 'NICARAGUA',
	[EPaises.NIGER]: 'NÍGER',
	[EPaises.NIGERIA]: 'NIGERIA',
	[EPaises.NORUEGA]: 'NORUEGA',
	[EPaises.NUEVA_CALEDONIA]: 'NUEVA CALEDONIA',
	[EPaises.NUEVA_ZELANDIA]: 'NUEVA ZELANDIA',
	[EPaises.OMAN]: 'OMÁN',
	[EPaises.PAISES_BAJOS]: 'PAÍSES BAJOS',
	[EPaises.PAKISTAN]: 'PAKISTÁN',
	[EPaises.PALAU]: 'PALAU',
	[EPaises.PALESTINA]: 'PALESTINA',
	[EPaises.PANAMA]: 'PANAMÁ',
	[EPaises.PAPUA_NUEVA_GUINEA]: 'PAPÚA NUEVA GUINEA',
	[EPaises.PARAGUAY]: 'PARAGUAY',
	[EPaises.PERU]: 'PERÚ',
	[EPaises.POLINESIA_FRANCESA]: 'POLINESIA FRANCESA',
	[EPaises.POLONIA]: 'POLONIA',
	[EPaises.PORTUGAL]: 'PORTUGAL',
	[EPaises.PUERTO_RICO]: 'PUERTO RICO',
	[EPaises.QATAR]: 'QATAR',
	[EPaises.REINO_UNIDO]: 'REINO UNIDO',
	[EPaises.REPUBLICA_CENTROAFRICANA]: 'REPÚBLICA CENTROAFRICANA',
	[EPaises.REPUBLICA_CHECA]: 'REPÚBLICA CHECA',
	[EPaises.REUNION]: 'REUNIÓN',
	[EPaises.RUMANIA]: 'RUMANÍA',
	[EPaises.RUSIA]: 'RUSIA',
	[EPaises.RWANDA]: 'RWANDA',
	[EPaises.SAHARA_OCCIDENTAL]: 'SÁHARA OCCIDENTAL',
	[EPaises.SAN_BARTOLOME]: 'SAN BARTOLOMÉ',
	[EPaises.SAINT_KITTS_Y_NEVIS]: 'SAINT KITTS Y NEVIS',
	[EPaises.SAINT_MARTIN]: 'SAINT MARTIN',
	[EPaises.ISLAS_SALOMON]: 'ISLAS SALOMÓN',
	[EPaises.SAMOA]: 'SAMOA',
	[EPaises.SAMOA_AMERICANA]: 'SAMOA AMERICANA',
	[EPaises.SAN_MARINO]: 'SAN MARINO',
	[EPaises.SAN_PEDRO_Y_MIQUELON]: 'SAN PEDRO Y MIQUELÓN',
	[EPaises.SAN_VICENTE_Y_LAS_GRANADINAS]: 'SAN VICENTE Y LAS GRANADINAS',
	[EPaises.SANTA_HELENA]: 'SANTA HELENA',
	[EPaises.SANTA_LUCIA]: 'SANTA LUCÍA',
	[EPaises.SANTA_SEDE]: 'SANTA SEDE',
	[EPaises.SANTO_TOME_Y_PRINCIPE]: 'SANTO TOMÉ Y PRÍNCIPE',
	[EPaises.SENEGAL]: 'SENEGAL',
	[EPaises.SERBIA]: 'SERBIA',
	[EPaises.SEYCHELLES]: 'SEYCHELLES',
	[EPaises.SIERRA_LEONA]: 'SIERRA LEONA',
	[EPaises.SINGAPUR]: 'SINGAPUR',
	[EPaises.SINT_MAARTEN]: 'SINT MAARTEN',
	[EPaises.SOMALIA]: 'SOMALIA',
	[EPaises.SRI_LANKA]: 'SRI LANKA',
	[EPaises.SUDAFRICA]: 'SUDÁFRICA',
	[EPaises.SUDAN]: 'SUDÁN',
	[EPaises.SUDAN_DEL_SUR]: 'SUDÁN DEL SUR',
	[EPaises.SUECIA]: 'SUECIA',
	[EPaises.SUIZA]: 'SUIZA',
	[EPaises.SURINAME]: 'SURINAME',
	[EPaises.TAILANDIA]: 'TAILANDIA',
	[EPaises.TAIWAN]: 'TAIWÁN',
	[EPaises.TANZANIA]: 'TANZANIA',
	[EPaises.TAYIKISTAN]: 'TAYIKISTÁN',
	[EPaises.TIMOR_LESTE]: 'TIMOR LESTE',
	[EPaises.TOGO]: 'TOGO',
	[EPaises.TOKELAU]: 'TOKELAU',
	[EPaises.TONGA]: 'TONGA',
	[EPaises.TRINIDAD_Y_TOBAGO]: 'TRINIDAD Y TOBAGO',
	[EPaises.TUNEZ]: 'TÚNEZ',
	[EPaises.TURCAS_Y_CAICOS]: 'TURCAS Y CAICOS, ISLAS',
	[EPaises.TURKMENISTAN]: 'TURKMENISTÁN',
	[EPaises.TURQUIA]: 'TURQUÍA',
	[EPaises.TUVALU]: 'TUVALU',
	[EPaises.UCRANIA]: 'UCRANIA',
	[EPaises.UGANDA]: 'UGANDA',
	[EPaises.URUGUAY]: 'URUGUAY',
	[EPaises.UZBEKISTAN]: 'UZBEKISTÁN',
	[EPaises.VANUATU]: 'VANUATU',
	[EPaises.VENEZUELA]: 'VENEZUELA',
	[EPaises.VIETNAM]: 'VIETNAM',
	[EPaises.VIRGENES_BRITANICAS]: 'VIRGÉNES BRITÁNICAS, ISLAS',
	[EPaises.VIRGENES_ESTADOS_UNIDOS]: 'VIRGÉNES ESTADOS UNIDOS, ISLAS',
	[EPaises.WALLIS_Y_FUTUNA]: 'WALLIS Y FUTUNA',
	[EPaises.YEMEN]: 'YEMEN',
	[EPaises.ZAMBIA]: 'ZAMBIA',
	[EPaises.ZIMBABWE]: 'ZIMBABWE',
	[EPaises.POR_DEFINIR]: 'POR DEFINIR',
	[EPaises.VATICANO]: 'VATICANO',
	[EPaises.COSTA_DE_MARFIL_ALT]: 'COSTA DE MARFIL ALT',
	[EPaises.MONTENEGRO]: 'MONTENEGRO',
	[EPaises.SIRIA]: 'SIRIA',
	[EPaises.GEORGIA_DEL_SUR_Y_SANDWICH_DEL_SUR]: 'GEORGIA DEL SUR Y SANDWICH DEL SUR',
	[EPaises.HEARD_E_ISLAS_MCDONALD]: 'HEARD E ISLAS MCDONALD',
	[EPaises.ISLAS_ULTRAMARINAS_MENORES_DE_ESTADOS_UNIDOS]: 'ISLAS ULTRAMARINAS MENORES DE ESTADOS UNIDOS',
	[EPaises.ISLA_DE_NAVIDAD]: 'ISLA DE NAVIDAD',
	[EPaises.NIUE]: 'NIUE',
	[EPaises.ISLA_NORFOLK]: 'ISLA NORFOLK',
	[EPaises.PITCAIRN]: 'PITCAIRN',
	[EPaises.SVALBARD_Y_JAN_MAYEN]: 'SVALBARD Y JAN MAYEN',
	[EPaises.SWAZILANDIA]: 'SWAZILANDIA',
	[EPaises.TERRITORIO_BRITANICO_DEL_OCEANO_INDICO]: 'TERRITORIO BRITANICO DEL OCEANO INDICO',
	[EPaises.TIERRAS_AUSTRALES_FRANCESAS]: 'TIERRAS AUSTRALES FRANCESAS'
}
export enum EEntidadFederativa {
	AGUASCALIENTES = '01',
	BAJA_CALIFORNIA = '02',
	BAJA_CALIFORNIA_SUR = '03',
	CAMPECHE = '04',
	COAHUILA_DE_ZARAGOZA = '05',
	COLIMA = '06',
	CHIAPAS = '07',
	CHIHUAHUA = '08',
	CIUDAD_DE_MEXICO = '09',
	DURANGO = '10',
	GUANAJUATO = '11',
	GUERRERO = '12',
	HIDALGO = '13',
	JALISCO = '14',
	MEXICO = '15',
	MICHOACAN_DE_OCAMPO = '16',
	MORELOS = '17',
	NAYARIT = '18',
	NUEVO_LEON = '19',
	OAXACA = '20',
	PUEBLA = '21',
	QUERETARO = '22',
	QUINTANA_ROO = '23',
	SAN_LUIS_POTOSI = '24',
	SINALOA = '25',
	SONORA = '26',
	TABASCO = '27',
	TAMAULIPAS = '28',
	TLAXCALA = '29',
	VERACRUZ_DE_IGNACIO_DE_LA_LLAVE = '30',
	YUCATAN = '31',
	ZACATECAS = '32',
	ALABAMA = '33',
	ALASKA = '34',
	ARIZONA = '35',
	ARKANSAS = '36',
	CALIFORNIA = '37',
	COLORADO = '38',
	CONNECTICUT = '39',
	DELAWARE = '40',
	FLORIDA = '41',
	GEORGIA = '42',
	HAWAII = '43',
	ILLINOIS = '44',
	INDIANA = '45',
	IOWA = '46',
	KANSAS = '47',
	KENTUCKY = '48',
	LOUISIANA = '49',
	MAINE = '50',
	MARYLAND = '51',
	MASSACHUSETTS = '52',
	MICHIGAN = '53',
	MINNESOTA = '54',
	MISSISSIPPI = '55',
	MISSOURI = '56',
	MONTANA = '57',
	NEBRASKA = '58',
	NEVADA = '59',
	NEW_HAMPSHIRE = '60',
	NEW_JERSEY = '61',
	NEW_MEXICO = '62',
	NEW_YORK = '63',
	NORTH_CAROLINA = '64',
	NORTH_DAKOTA = '65',
	OHIO = '66',
	OKLAHOMA = '67',
	OREGON = '68',
	PENNSYLVANIA = '69',
	RHODE_ISLAND = '70',
	SOUTH_CAROLINA = '71',
	SOUTH_DAKOTA = '72',
	TENNESSEE = '73',
	TEXAS = '74',
	UTAH = '75',
	VERMONT = '76',
	VIRGINIA = '77',
	WASHINGTON = '78',
	WEST_VIRGINIA = '79',
	WISCONSIN = '80',
	WYOMING = '81',
	IDAHO = '82',
	ONTARIO = '83',
	QUEBEC = '84',
	NOVA_ESCOTIA = '85',
	NOVA_BRUNSWICK = '86',
	MANITOBA = '87',
	COLUMBIA_BRITANICA = '88',
	ISLA_DEL_PRINCIPE_EDUARDO = '89',
	SASKATCHEWAN = '90',
	ALBERTA = '91',
	TERRA_NOVA_Y_LABRADOR = '92',
	TERRITORIOS_DEL_NOROESTE = '93',
	YUKON = '94',
	NUNAVUT = '95',
	FORANEO = '96'
}
export const CEntidadFederativa: Record<EEntidadFederativa, string> = {
	[EEntidadFederativa.AGUASCALIENTES]: 'AGUASCALIENTES',
	[EEntidadFederativa.BAJA_CALIFORNIA]: 'BAJA CALIFORNIA',
	[EEntidadFederativa.BAJA_CALIFORNIA_SUR]: 'BAJA CALIFORNIA SUR',
	[EEntidadFederativa.CAMPECHE]: 'CAMPECHE',
	[EEntidadFederativa.COAHUILA_DE_ZARAGOZA]: 'COAHUILA DE ZARAGOZA',
	[EEntidadFederativa.COLIMA]: 'COLIMA',
	[EEntidadFederativa.CHIAPAS]: 'CHIAPAS',
	[EEntidadFederativa.CHIHUAHUA]: 'CHIHUAHUA',
	[EEntidadFederativa.CIUDAD_DE_MEXICO]: 'CIUDAD DE MÉXICO',
	[EEntidadFederativa.DURANGO]: 'DURANGO',
	[EEntidadFederativa.GUANAJUATO]: 'GUANAJUATO',
	[EEntidadFederativa.GUERRERO]: 'GUERRERO',
	[EEntidadFederativa.HIDALGO]: 'HIDALGO',
	[EEntidadFederativa.JALISCO]: 'JALISCO',
	[EEntidadFederativa.MEXICO]: 'MÉXICO',
	[EEntidadFederativa.MICHOACAN_DE_OCAMPO]: 'MICHOACÁN DE OCAMPO',
	[EEntidadFederativa.MORELOS]: 'MORELOS',
	[EEntidadFederativa.NAYARIT]: 'NAYARIT',
	[EEntidadFederativa.NUEVO_LEON]: 'NUEVO LEÓN',
	[EEntidadFederativa.OAXACA]: 'OAXACA',
	[EEntidadFederativa.PUEBLA]: 'PUEBLA',
	[EEntidadFederativa.QUERETARO]: 'QUERÉTARO',
	[EEntidadFederativa.QUINTANA_ROO]: 'QUINTANA ROO',
	[EEntidadFederativa.SAN_LUIS_POTOSI]: 'SAN LUIS POTOSÍ',
	[EEntidadFederativa.SINALOA]: 'SINALOA',
	[EEntidadFederativa.SONORA]: 'SONORA',
	[EEntidadFederativa.TABASCO]: 'TABASCO',
	[EEntidadFederativa.TAMAULIPAS]: 'TAMAULIPAS',
	[EEntidadFederativa.TLAXCALA]: 'TLAXCALA',
	[EEntidadFederativa.VERACRUZ_DE_IGNACIO_DE_LA_LLAVE]: 'VERACRUZ DE IGNACIO DE LA LLAVE',
	[EEntidadFederativa.YUCATAN]: 'YUCATÁN',
	[EEntidadFederativa.ZACATECAS]: 'ZACATECAS',
	[EEntidadFederativa.ALABAMA]: 'ALABAMA',
	[EEntidadFederativa.ALASKA]: 'ALASKA',
	[EEntidadFederativa.ARIZONA]: 'ARIZONA',
	[EEntidadFederativa.ARKANSAS]: 'ARKANSAS',
	[EEntidadFederativa.CALIFORNIA]: 'CALIFORNIA',
	[EEntidadFederativa.COLORADO]: 'COLORADO',
	[EEntidadFederativa.CONNECTICUT]: 'CONNECTICUT',
	[EEntidadFederativa.DELAWARE]: 'DELAWARE',
	[EEntidadFederativa.FLORIDA]: 'FLORIDA',
	[EEntidadFederativa.GEORGIA]: 'GEORGIA',
	[EEntidadFederativa.HAWAII]: 'HAWAII',
	[EEntidadFederativa.ILLINOIS]: 'ILLINOIS',
	[EEntidadFederativa.INDIANA]: 'INDIANA',
	[EEntidadFederativa.IOWA]: 'IOWA',
	[EEntidadFederativa.KANSAS]: 'KANSAS',
	[EEntidadFederativa.KENTUCKY]: 'KENTUCKY',
	[EEntidadFederativa.LOUISIANA]: 'LOUISIANA',
	[EEntidadFederativa.MAINE]: 'MAINE',
	[EEntidadFederativa.MARYLAND]: 'MARYLAND',
	[EEntidadFederativa.MASSACHUSETTS]: 'MASSACHUSETTS',
	[EEntidadFederativa.MICHIGAN]: 'MICHIGAN',
	[EEntidadFederativa.MINNESOTA]: 'MINNESOTA',
	[EEntidadFederativa.MISSISSIPPI]: 'MISSISSIPPI',
	[EEntidadFederativa.MISSOURI]: 'MISSOURI',
	[EEntidadFederativa.MONTANA]: 'MONTANA',
	[EEntidadFederativa.NEBRASKA]: 'NEBRASKA',
	[EEntidadFederativa.NEVADA]: 'NEVADA',
	[EEntidadFederativa.NEW_HAMPSHIRE]: 'NEW HAMPSHIRE',
	[EEntidadFederativa.NEW_JERSEY]: 'NEW JERSEY',
	[EEntidadFederativa.NEW_MEXICO]: 'NEW MÉXICO',
	[EEntidadFederativa.NEW_YORK]: 'NEW YORK',
	[EEntidadFederativa.NORTH_CAROLINA]: 'NORTH CAROLINA',
	[EEntidadFederativa.NORTH_DAKOTA]: 'NORTH DAKOTA',
	[EEntidadFederativa.OHIO]: 'OHIO',
	[EEntidadFederativa.OKLAHOMA]: 'OKLAHOMA',
	[EEntidadFederativa.OREGON]: 'OREGON',
	[EEntidadFederativa.PENNSYLVANIA]: 'PENNSYLVANIA',
	[EEntidadFederativa.RHODE_ISLAND]: 'RHODE ISLAND',
	[EEntidadFederativa.SOUTH_CAROLINA]: 'SOUTH CAROLINA',
	[EEntidadFederativa.SOUTH_DAKOTA]: 'SOUTH DAKOTA',
	[EEntidadFederativa.TENNESSEE]: 'TENNESSEE',
	[EEntidadFederativa.TEXAS]: 'TEXAS',
	[EEntidadFederativa.UTAH]: 'UTAH',
	[EEntidadFederativa.VERMONT]: 'VERMONT',
	[EEntidadFederativa.VIRGINIA]: 'VIRGINIA',
	[EEntidadFederativa.WASHINGTON]: 'WASHINGTON',
	[EEntidadFederativa.WEST_VIRGINIA]: 'WEST VIRGINIA',
	[EEntidadFederativa.WISCONSIN]: 'WISCONSIN',
	[EEntidadFederativa.WYOMING]: 'WYOMING',
	[EEntidadFederativa.IDAHO]: 'IDAHO',
	[EEntidadFederativa.ONTARIO]: 'ONTARIO',
	[EEntidadFederativa.QUEBEC]: 'QUEBEC',
	[EEntidadFederativa.NOVA_ESCOTIA]: 'NOVA ESCOTIA',
	[EEntidadFederativa.NOVA_BRUNSWICK]: 'NOVA BRUNSWICK',
	[EEntidadFederativa.MANITOBA]: 'MANITOBA',
	[EEntidadFederativa.COLUMBIA_BRITANICA]: 'COLUMBIA BRITANICA',
	[EEntidadFederativa.ISLA_DEL_PRINCIPE_EDUARDO]: 'ISLA DEL PRINCIPE EDUARDO',
	[EEntidadFederativa.SASKATCHEWAN]: 'SASKATCHEWAN',
	[EEntidadFederativa.ALBERTA]: 'ALBERTA',
	[EEntidadFederativa.TERRA_NOVA_Y_LABRADOR]: 'TERRA NOVA Y LABRADOR',
	[EEntidadFederativa.TERRITORIOS_DEL_NOROESTE]: 'TERRITORIOS DEL NOROESTE',
	[EEntidadFederativa.YUKON]: 'YUKON',
	[EEntidadFederativa.NUNAVUT]: 'NUNAVUT',
	[EEntidadFederativa.FORANEO]: 'FORANEO'
}
export enum EGenderPUI {
	HOMBRE = 'H',
	MUJER = 'M',
	OTRO = 'O'
}
export const CGenderPUI: Record<EGenderPUI, string> = {
	[EGenderPUI.HOMBRE]: 'HOMBRE',
	[EGenderPUI.MUJER]: 'MUJER',
	[EGenderPUI.OTRO]: 'OTRO'
}
export enum EModalidadEducativa {
	ESCOLARIZADA = '1',
	NO_ESCOLARIZADA = '2',
	MIXTA = '3',
	DUAL = '4'
}
export const CModalidadEducativa: Record<EModalidadEducativa, string> = {
	[EModalidadEducativa.ESCOLARIZADA]: 'ESCOLARIZADA',
	[EModalidadEducativa.NO_ESCOLARIZADA]: 'NO ESCOLARIZADA',
	[EModalidadEducativa.MIXTA]: 'MIXTA',
	[EModalidadEducativa.DUAL]: 'DUAL'
}

export enum EOpcionEducativa {
	PRESENCIAL_ESCOLARIZADA = '1',
	EN_LINEA_VIRTUAL_NO_ESCOLARIZADA = '2',
	ABIERTA_DISTANCIA_NO_ESCOLARIZADA = '3',
	CERTIFICACION_POR_EXAMEN_NO_ESCOLARIZADA = '4',
	EN_LINEA_VIRTUAL_MIXTA = '5',
	ABIERTA_DISTANCIA_MIXTA = '6',
	DUAL = '7',
	PRESENCIAL_VIRTUAL = '8'
}
export const COpcionEducativa: Record<EOpcionEducativa, string> = {
	[EOpcionEducativa.PRESENCIAL_ESCOLARIZADA]: 'PRESENCIAL/ESCOLARIZADA',
	[EOpcionEducativa.EN_LINEA_VIRTUAL_NO_ESCOLARIZADA]: 'EN LÍNEA VIRTUAL/NO ESCOLARIZADA',
	[EOpcionEducativa.ABIERTA_DISTANCIA_NO_ESCOLARIZADA]: 'ABIERTA A DISTANCIA/NO ESCOLARIZADA',
	[EOpcionEducativa.CERTIFICACION_POR_EXAMEN_NO_ESCOLARIZADA]: 'CERTIFICACIÓN POR EXAMEN/NO ESCOLARIZADA',
	[EOpcionEducativa.EN_LINEA_VIRTUAL_MIXTA]: 'EN LÍNEA VIRTUAL/MIXTA',
	[EOpcionEducativa.ABIERTA_DISTANCIA_MIXTA]: 'ABIERTA A DISTANCIA/MIXTA',
	[EOpcionEducativa.DUAL]: 'DUAL',
	[EOpcionEducativa.PRESENCIAL_VIRTUAL]: 'PRESENCIAL VIRTUAL'
}
export const CRelacionOpcionModalidad: Record<EModalidadEducativa, readonly EOpcionEducativa[]> = {
	[EModalidadEducativa.ESCOLARIZADA]: [EOpcionEducativa.PRESENCIAL_ESCOLARIZADA],
	[EModalidadEducativa.NO_ESCOLARIZADA]: [
		EOpcionEducativa.EN_LINEA_VIRTUAL_NO_ESCOLARIZADA,
		EOpcionEducativa.ABIERTA_DISTANCIA_NO_ESCOLARIZADA,
		EOpcionEducativa.CERTIFICACION_POR_EXAMEN_NO_ESCOLARIZADA
	],
	[EModalidadEducativa.MIXTA]: [EOpcionEducativa.EN_LINEA_VIRTUAL_MIXTA, EOpcionEducativa.ABIERTA_DISTANCIA_MIXTA, EOpcionEducativa.PRESENCIAL_VIRTUAL],
	[EModalidadEducativa.DUAL]: [EOpcionEducativa.DUAL]
}

export enum ETipoTurno {
	MATUTINO = '1',
	VESPERTINO = '2',
	MIXTO = '4',
	ABIERTO = '6'
}
export const CTipoTurno: Record<ETipoTurno, string> = {
	[ETipoTurno.MATUTINO]: 'MATUTINO',
	[ETipoTurno.VESPERTINO]: 'VESPERTINO',
	[ETipoTurno.MIXTO]: 'MIXTO',
	[ETipoTurno.ABIERTO]: 'ABIERTO'
}
export enum EPeriodo {
	PRIMER = '1',
	SEGUNDO = '2',
	TERCERO = '3',
	CUARTO = '4',
	QUINTO = '5',
	SEXTO = '6',
	SEPTIMO = '7',
	OCTAVO = '8',
	NOVENO = '9',
	DECIMO = '10',
	UNIDECIMO = '11',
	DOUDECIMO = '12',
	DECIMO_TERCERO = '13',
	DECIMO_CUARTO = '14',
	DECIMO_QUINTO = '15',
	DECIMO_SEXTO = '16',
	DECIMO_SEPTIMO = '17',
	DECIMO_OCTAVO = '18',
	DECIMO_NOVENO = '19',
	VIGESIMO = '20',
	VIGECIMO_PRIMERO = '21',
	VIGECIMO_SEGUNDO = '22',
	VIGECIMO_TERCERO = '23',
	VIGECIMO_CUARTO = '24',
	UNICO = '25'
}
export const CPeriodo: Record<EPeriodo, string> = {
	[EPeriodo.PRIMER]: 'PRIMER',
	[EPeriodo.SEGUNDO]: 'SEGUNDO',
	[EPeriodo.TERCERO]: 'TERCERO',
	[EPeriodo.CUARTO]: 'CUARTO',
	[EPeriodo.QUINTO]: 'QUINTO',
	[EPeriodo.SEXTO]: 'SEXTO',
	[EPeriodo.SEPTIMO]: 'SÉPTIMO',
	[EPeriodo.OCTAVO]: 'OCTAVO',
	[EPeriodo.NOVENO]: 'NOVENO',
	[EPeriodo.DECIMO]: 'DÉCIMO',
	[EPeriodo.UNIDECIMO]: 'UNDÉCIMO',
	[EPeriodo.DOUDECIMO]: 'DUODÉCIMO',
	[EPeriodo.DECIMO_TERCERO]: 'DÉCIMO TERCERO',
	[EPeriodo.DECIMO_CUARTO]: 'DÉCIMO CUARTO',
	[EPeriodo.DECIMO_QUINTO]: 'DÉCIMO QUINTO',
	[EPeriodo.DECIMO_SEXTO]: 'DÉCIMO SEXTO',
	[EPeriodo.DECIMO_SEPTIMO]: 'DÉCIMO SÉPTIMO',
	[EPeriodo.DECIMO_OCTAVO]: 'DÉCIMO OCTAVO',
	[EPeriodo.DECIMO_NOVENO]: 'DÉCIMO NOVENO',
	[EPeriodo.VIGESIMO]: 'VIGÉSIMO',
	[EPeriodo.VIGECIMO_PRIMERO]: 'VIGÉSIMO PRIMERO',
	[EPeriodo.VIGECIMO_SEGUNDO]: 'VIGÉSIMO SEGUNDO',
	[EPeriodo.VIGECIMO_TERCERO]: 'VIGÉSIMO TERCERO',
	[EPeriodo.VIGECIMO_CUARTO]: 'VIGÉSIMO CUARTO',
	[EPeriodo.UNICO]: 'ÚNICO'
}

export enum EGradoPlanEstudio {
	PRIMER = '1',
	SEGUNDO = '2',
	TERCERO = '3',
	CUARTO = '4',
	QUINTO = '5',
	SEXTO = '6',
	SEPTIMO = '7',
	OCTAVO = '8',
	NOVENO = '9',
	DECIMO = '10',
	UNIDECIMO = '11',
	DOUDECIMO = '12',
	DECIMO_TERCERO = '13',
	DECIMO_CUARTO = '14',
	DECIMO_QUINTO = '15',
	DECIMO_SEXTO = '16',
	DECIMO_SEPTIMO = '17',
	DECIMO_OCTAVO = '18',
	DECIMO_NOVENO = '19',
	VIGESIMO = '20',
	VIGECIMO_PRIMERO = '21',
	VIGECIMO_SEGUNDO = '22',
	VIGECIMO_TERCERO = '23',
	UNICO = '24'
}
export const CGradoPlanEstudio: Record<EGradoPlanEstudio, string> = {
	[EGradoPlanEstudio.PRIMER]: 'PRIMER',
	[EGradoPlanEstudio.SEGUNDO]: 'SEGUNDO',
	[EGradoPlanEstudio.TERCERO]: 'TERCERO',
	[EGradoPlanEstudio.CUARTO]: 'CUARTO',
	[EGradoPlanEstudio.QUINTO]: 'QUINTO',
	[EGradoPlanEstudio.SEXTO]: 'SEXTO',
	[EPeriodo.SEPTIMO]: 'SÉPTIMO',
	[EGradoPlanEstudio.OCTAVO]: 'OCTAVO',
	[EGradoPlanEstudio.NOVENO]: 'NOVENO',
	[EGradoPlanEstudio.DECIMO]: 'DÉCIMO',
	[EGradoPlanEstudio.UNIDECIMO]: 'UNDÉCIMO',
	[EGradoPlanEstudio.DOUDECIMO]: 'DUODÉCIMO',
	[EGradoPlanEstudio.DECIMO_TERCERO]: 'DÉCIMO TERCERO',
	[EGradoPlanEstudio.DECIMO_CUARTO]: 'DÉCIMO CUARTO',
	[EGradoPlanEstudio.DECIMO_QUINTO]: 'DÉCIMO QUINTO',
	[EGradoPlanEstudio.DECIMO_SEXTO]: 'DÉCIMO SEXTO',
	[EGradoPlanEstudio.DECIMO_SEPTIMO]: 'DÉCIMO SÉPTIMO',
	[EGradoPlanEstudio.DECIMO_OCTAVO]: 'DÉCIMO OCTAVO',
	[EGradoPlanEstudio.DECIMO_NOVENO]: 'DÉCIMO NOVENO',
	[EGradoPlanEstudio.VIGESIMO]: 'VIGÉSIMO',
	[EGradoPlanEstudio.VIGECIMO_PRIMERO]: 'VIGÉSIMO PRIMERO',
	[EGradoPlanEstudio.VIGECIMO_SEGUNDO]: 'VIGÉSIMO SEGUNDO',
	[EGradoPlanEstudio.VIGECIMO_TERCERO]: 'VIGÉSIMO TERCERO',
	[EGradoPlanEstudio.UNICO]: 'ÚNICO'
}
export enum EAnioEscolar {
	PRIMER = '1',
	SEGUNDO = '2',
	TERCERO = '3',
	CUARTO = '4',
	QUINTO = '5',
	SEXTO = '6'
}
export const CAnioEscolar: Record<EAnioEscolar, string> = {
	[EAnioEscolar.PRIMER]: 'PRIMER',
	[EAnioEscolar.SEGUNDO]: 'SEGUNDO',
	[EAnioEscolar.TERCERO]: 'TERCERO',
	[EAnioEscolar.CUARTO]: 'CUARTO',
	[EAnioEscolar.QUINTO]: 'QUINTO',
	[EAnioEscolar.SEXTO]: 'SEXTO'
}
export enum ENacionalidad {
	MEXICANO = 1,
	EXTRANJERO = 2
}
export const CNacionalidad: Record<ENacionalidad, string> = {
	[ENacionalidad.MEXICANO]: 'MEXICANO',
	[ENacionalidad.EXTRANJERO]: 'EXTRANJERO'
}
export enum ENecesidadEducativa {
	NO_APLICA = '00',
	DISCAPACIDAD = '01',
	APTITUDES_SOBRESALIENTES = '02'
}
export const CNEcesidadEducativa: Record<ENecesidadEducativa, string> = {
	[ENecesidadEducativa.NO_APLICA]: 'NO APLICA',
	[ENecesidadEducativa.DISCAPACIDAD]: 'DISCAPACIDAD',
	[ENecesidadEducativa.APTITUDES_SOBRESALIENTES]: 'APTITUDES SOBRESALIENTES'
}
export enum EDiscapacidad {
	INTELECTUAL = '1',
	MOTRIZ = '2',
	AUDITIVA_SORDERA = '3',
	AUDITIVA_HIPOACUSIA = '4',
	VISUAL_CEGUERA = '5',
	VISUAL_BAJA_VISION = '6',
	MULTIPLE = '7',
	SORDOCEGUERA = '8',
	MENTAL_PSICOSOCIAL = '9',
	TRANTORNO_DEL_ESPECTRO_AUTISTA = '10',
	DEFICIT_DE_ATENCION_E_HIPERACTIVIDAD = '11',
	OTRO = '12',
	SEVERA_DE_CONDUCTA = '13',
	SEVERA_DE_COMUNICACION = '14',
	SEVERA_DE_APRENDIZAJE = '15'
}
export const CDiscapacidad: Record<EDiscapacidad, string> = {
	[EDiscapacidad.INTELECTUAL]: 'INTELECTUAL',
	[EDiscapacidad.MOTRIZ]: 'MOTRIZ',
	[EDiscapacidad.AUDITIVA_SORDERA]: 'AUDITIVA SORDERA',
	[EDiscapacidad.AUDITIVA_HIPOACUSIA]: 'AUDITIVA HIPOACUSIA',
	[EDiscapacidad.VISUAL_CEGUERA]: 'VISUAL CEGUERA',
	[EDiscapacidad.VISUAL_BAJA_VISION]: 'VISUAL BAJA VISION',
	[EDiscapacidad.MULTIPLE]: 'MÚLTIPLE',
	[EDiscapacidad.SORDOCEGUERA]: 'SORDOCEGUERA',
	[EDiscapacidad.MENTAL_PSICOSOCIAL]: 'MENTAL PSICOSOCIAL',
	[EDiscapacidad.TRANTORNO_DEL_ESPECTRO_AUTISTA]: 'TRANTORNO DEL ESPECTRO AUTISTA',
	[EDiscapacidad.DEFICIT_DE_ATENCION_E_HIPERACTIVIDAD]: 'DEFICIT DE ATENCIÓN E HIPERACTIVIDAD',
	[EDiscapacidad.OTRO]: 'OTRO',
	[EDiscapacidad.SEVERA_DE_CONDUCTA]: 'SEVERA DE CONDUCTA',
	[EDiscapacidad.SEVERA_DE_COMUNICACION]: 'SEVERA DE COMUNICACIÓN',
	[EDiscapacidad.SEVERA_DE_APRENDIZAJE]: 'SEVERA DE APRENDIZAJE'
}
export enum EAptitudesSobresalientes {
	INTELECTUAL = '1',
	CREATIVA = '2',
	SOCIOAFECTIVA = '3',
	ARTISTICA = '4',
	PSICOMOTRIZ = '5',
	OTRO = '12'
}
export const CAptitudesSobresalientes: Record<EAptitudesSobresalientes, string> = {
	[EAptitudesSobresalientes.INTELECTUAL]: 'INTELECTUAL',
	[EAptitudesSobresalientes.CREATIVA]: 'CREATIVA',
	[EAptitudesSobresalientes.SOCIOAFECTIVA]: 'SOCIOAFECTIVA',
	[EAptitudesSobresalientes.ARTISTICA]: 'ARTISTICA',
	[EAptitudesSobresalientes.PSICOMOTRIZ]: 'PSICOMOTRIZ',
	[EAptitudesSobresalientes.OTRO]: 'OTRO'
}
export enum EConfirmacion {
	SI = 'S',
	NO = 'N'
}
export const CConfirmacion: Record<EConfirmacion, string> = {
	[EConfirmacion.SI]: 'SI',
	[EConfirmacion.NO]: 'NO'
}
export enum ETipoAntecedente {
	CB_TECNICO_SUPERIOR_UNIVERSITARIO = '1',
	CB_PROFESIONAL_ASOCIADO = '2',
	CB_LICENCIATURA = '3',
	TSU_LICENCIATURA = '4',
	TCICL_ESPECIALIDAD = '5',
	TCICOE_ESPECIALIDAD = '6',
	TCICL_MAESTRIA = '7',
	TCICOE_MAESTRIA = '8',
	TCICM_DOCTORADO = '9',
	TCICL_DOCTORADO = '10',
	DREB_LICENCIATURA = '11',
	DEES_LICENCIATURA = '12',
	DEES_MAESTRIA = '13',
	DEES_ESPECIALIDAD = '14',
	DRES_LICENCIATURA = '15',
	DRES_MAESTRIA = '16',
	DRES_ESPECIALIDAD = '17',
	CCPES_LICENCIATURA = '18'
}
export const CTipoAntecedente: Record<ETipoAntecedente, string> = {
	[ETipoAntecedente.CB_TECNICO_SUPERIOR_UNIVERSITARIO]: 'Certificado de Bachillerato-Técnico Superior Universitario',
	[ETipoAntecedente.CB_PROFESIONAL_ASOCIADO]: 'Certificado de Bachillerato-Profesional Asociado',
	[ETipoAntecedente.CB_LICENCIATURA]: 'Certificado de Bachillerato-Licenciatura',
	[ETipoAntecedente.TSU_LICENCIATURA]: 'Certificado TSU Licenciatura',
	[ETipoAntecedente.TCICL_ESPECIALIDAD]: 'Título o constancia institucional de haber concluido la Licenciatura-Especialidad',
	[ETipoAntecedente.TCICOE_ESPECIALIDAD]: 'Título o constancia institucional de haber concluido otra Especialidad-Especialidad',
	[ETipoAntecedente.TCICL_MAESTRIA]: 'Título o constancia institucional de haber concluido la Licenciatura-Maestría',
	[ETipoAntecedente.TCICOE_MAESTRIA]: 'Título o constancia institucional de haber concluido otra Especialidad-Maestría',
	[ETipoAntecedente.TCICM_DOCTORADO]: 'Título o constancia institucional de haber concluido la Maestría-Doctorado',
	[ETipoAntecedente.TCICL_DOCTORADO]: 'Título o constancia institucional de haber concluido la Licenciatura-Doctorado',
	[ETipoAntecedente.DREB_LICENCIATURA]: 'Documento de Revalidación de Estudios de Bachillerato-Licenciatura',
	[ETipoAntecedente.DEES_LICENCIATURA]: 'Documento de Equivalencia de Estudios Superiores-Licenciatura',
	[ETipoAntecedente.DEES_MAESTRIA]: 'Documento de Equivalencia de Estudios Superiores-Maestría',
	[ETipoAntecedente.DEES_ESPECIALIDAD]: 'Documento de Equivalencia de Estudios Superiores-Especialidad',
	[ETipoAntecedente.DRES_LICENCIATURA]: 'Documento de Revalidación de Estudios Superiores-Licenciatura',
	[ETipoAntecedente.DRES_MAESTRIA]: 'Documento de Revalidación de Estudios Superiores-Maestría',
	[ETipoAntecedente.DRES_ESPECIALIDAD]: 'Documento de Revalidación de Estudios Superiores-Especialidad',
	[ETipoAntecedente.CCPES_LICENCIATURA]: 'Constancia de cambio de Programa de Estudios Superiores-Licenciatura'
}
export enum EOrigenEstudios {
	NACIONALES = '02',
	EXTRANJEROS = '03'
}
export const COrigenEstudios: Record<EOrigenEstudios, string> = {
	[EOrigenEstudios.NACIONALES]: 'NACIONALES',
	[EOrigenEstudios.EXTRANJEROS]: 'EXTRANJEROS'
}
export enum EBajaAcademica {
	BAJA_TEMPORAL = 1,
	BAJA_DEFINITIVA = 2
}
export const CBajaAcademica: Record<EBajaAcademica, string> = {
	[EBajaAcademica.BAJA_TEMPORAL]: 'BAJA TEMPORAL',
	[EBajaAcademica.BAJA_DEFINITIVA]: 'BAJA DEFINITIVA'
}
export enum ETipoBajaAcademica {
	BAJA_POR_DIFICULTAD_DE_ACCESO = 1,
	BAJA_POR_CAMBIO_DE_DOMICILIO_PAIS = 2,
	BAJA_POR_CAMBIO_DE_DOMICILIO_ESTADO = 3,
	BAJA_POR_ADEUDO_DE_MATERIAS = 4,
	BAJA_POR_EMBARAZO = 5,
	BAJA_POR_FACTOR_ECONOMICO = 6,
	BAJA_POR_TRABAJO = 7,
	BAJA_POR_ENFERMEDAD = 8,
	BAJA_POR_DEFUNCION = 9,
	BAJA_DICIPLINARIA = 10,
	BAJA_POR_MOTIVOS_EMOCIONALES = 11,
	BAJA_POR_INSEGURIDAD = 12,
	BAJA_POR_ACOSO = 13,
	BAJA_POR_DROGAS = 14,
	BAJA_POR_ASUNTOS_FAMILIARES = 15,
	BAJA_POR_DESINTERES = 16,
	BAJA_POR_RESTRASO_ANTECEDENTES = 17,
	BAJA_POR_CONCLUSION_DE_ESTUDIOS = 18,
	BAJA_POR_OTRO = 19,
	BAJA_POR_CAMBIO_DE_PROGRAMA_DE_ESTUDIOS = 20,
	BAJA_POR_CAUSAS_ACADEMICAS = 21,
	BAJA_POR_CAMBIO_DE_INSTITUCION = 22,
	NO_REINSCRIPCION = 23
}
export const CTipoBajaAcademica: Record<ETipoBajaAcademica, string> = {
	[ETipoBajaAcademica.BAJA_POR_DIFICULTAD_DE_ACCESO]: 'Baja por dificultad de acceso/transporte al plantel (distancia)',
	[ETipoBajaAcademica.BAJA_POR_CAMBIO_DE_DOMICILIO_PAIS]: 'Baja por cambio de domicilio a otro país.',
	[ETipoBajaAcademica.BAJA_POR_CAMBIO_DE_DOMICILIO_ESTADO]: 'Baja por cambio de domicilio a otra entidad federativa',
	[ETipoBajaAcademica.BAJA_POR_ADEUDO_DE_MATERIAS]: 'Baja por adeudo de materias.',
	[ETipoBajaAcademica.BAJA_POR_EMBARAZO]: 'Baja por embarazo, maternidad, paternidad o matrimonio. (*)',
	[ETipoBajaAcademica.BAJA_POR_FACTOR_ECONOMICO]: 'Baja por factor económico.',
	[ETipoBajaAcademica.BAJA_POR_TRABAJO]: 'Baja por trabajo.',
	[ETipoBajaAcademica.BAJA_POR_ENFERMEDAD]: 'Baja por enfermedad crónica y/o estancia hospitalaria.',
	[ETipoBajaAcademica.BAJA_POR_DEFUNCION]: 'Baja por defunción.',
	[ETipoBajaAcademica.BAJA_DICIPLINARIA]: 'Baja por medida preventiva o disciplinaria del plantel.',
	[ETipoBajaAcademica.BAJA_POR_MOTIVOS_EMOCIONALES]: 'Baja por motivos emocionales.',
	[ETipoBajaAcademica.BAJA_POR_INSEGURIDAD]: 'Baja por violencia o inseguridad en el entorno social.',
	[ETipoBajaAcademica.BAJA_POR_ACOSO]: 'Baja por acoso escolar (reformular cómo se pregunta).',
	[ETipoBajaAcademica.BAJA_POR_DROGAS]: 'Baja por adicciones.',
	[ETipoBajaAcademica.BAJA_POR_ASUNTOS_FAMILIARES]: 'Baja por problemas o enfermedad familiar.',
	[ETipoBajaAcademica.BAJA_POR_DESINTERES]: 'Baja por desinterés o falta de motivación.',
	[ETipoBajaAcademica.BAJA_POR_RESTRASO_ANTECEDENTES]: 'Baja por retraso de entrega de antecedente académico.',
	[ETipoBajaAcademica.BAJA_POR_CONCLUSION_DE_ESTUDIOS]: 'Baja por conclusión de estudios del nivel educativo',
	[ETipoBajaAcademica.BAJA_POR_OTRO]: 'Baja por otro motivo.',
	[ETipoBajaAcademica.BAJA_POR_CAMBIO_DE_PROGRAMA_DE_ESTUDIOS]: 'Baja por cambio de programa de estudios ',
	[ETipoBajaAcademica.BAJA_POR_CAUSAS_ACADEMICAS]: 'Baja por causas académicas',
	[ETipoBajaAcademica.BAJA_POR_CAMBIO_DE_INSTITUCION]: 'Baja por cambio de institución',
	[ETipoBajaAcademica.NO_REINSCRIPCION]: 'No reinscripción'
}
export enum EFlujo {
	INSCRIPCION = 'I',
	REINSCRIPCION = 'R',
	BAJA = 'B'
}
export const CFlujo: Record<EFlujo, string> = {
	[EFlujo.INSCRIPCION]: 'INSCRIPCIÓN',
	[EFlujo.REINSCRIPCION]: 'REINSCRIPCIÓN',
	[EFlujo.BAJA]: 'BAJA'
}
export enum EDuracionPeriodo {
	SEMESTRAL = 1,
	CUATRIMESTRAL = 2,
	TRIMESTRAL = 3,
	BIMESTRAL = 4,
	MENSUAL = 5,
	QUINCENAL = 6,
	SEMANAL = 7,
	ANUAL = 8,
	DIARIO = 9,
	UNICO = 10
}
export const CDuracionPeriodo: Record<EDuracionPeriodo, string> = {
	[EDuracionPeriodo.SEMESTRAL]: 'Semestral',
	[EDuracionPeriodo.CUATRIMESTRAL]: 'Cuatrimestral',
	[EDuracionPeriodo.TRIMESTRAL]: 'Trimestral',
	[EDuracionPeriodo.BIMESTRAL]: 'Bimestral',
	[EDuracionPeriodo.MENSUAL]: 'Mensual',
	[EDuracionPeriodo.QUINCENAL]: 'Quincenal',
	[EDuracionPeriodo.SEMANAL]: 'Semanal',
	[EDuracionPeriodo.ANUAL]: 'Anual',
	[EDuracionPeriodo.DIARIO]: 'Diario',
	[EDuracionPeriodo.UNICO]: 'Único'
}
export enum EIdiomas {
	ACALA = '5001',
	AKATEKO = '0047',
	ALBANES = '7202',
	ALEMAN = '7011',
	ALEMAN_Y_OTROS_IDIOMAS = '7013',
	ALUSION_AL_MANEJO_DEL_CHECO = '7032',
	ALUSION_AL_MANEJO_DEL_HOLANDES = '7122',
	ALUSION_AL_MANEJO_DEL_INGLES = '7132',
	ALUSION_AL_MANEJO_DEL_TURCO = '7182',
	AMUZGO = '0030',
	ARABE = '7021',
	ARABE_Y_OTROS_IDIOMAS = '7023',
	AWAKATEKO = '0048',
	AYAPANECO = '0068',
	BENGALI = '7208',
	BIELORUSO = '7209',
	BISLAMA = '7211',
	BULGARO = '7212',
	CATALAN = '7214',
	CHOL = '0076',
	CHATINO = '0031',
	CHECO = '7031',
	CHECO_Y_OTROS_IDIOMAS = '7033',
	CHEYENE = '5522',
	CHICHIMECO_JONAZ = '0032',
	CHINANTECO = '0033',
	CHINO = '7041',
	CHINO_CANTONES = '7051',
	CHINO_CANTONES_Y_OTROS_IDIOMAS = '7053',
	CHINO_MANDARIN = '7061',
	CHINO_MANDARIN_Y_OTROS_IDIOMAS = '7063',
	CHINO_Y_OTROS_IDIOMAS = '7043',
	CHOCHOLTECO = '0034',
	CHONTAL_DE_OAXACA = '0074',
	CHONTAL_DE_TABASCO = '0077',
	CHUJ = '0049',
	CINGALES = '7216',
	CORA = '0013',
	COREANO = '7071',
	COREANO_Y_OTROS_IDIOMAS = '7073',
	CUCAPA = '0024',
	CUICATECO = '0035',
	DANES = '7220',
	EMBERA = '5537',
	ESLOVACO = '7221',
	ESLOVENO = '7222',
	ESPANOL = '0081',
	ESTONIO = '7223',
	FILIPINO = '7224',
	FINLANDES = '7225',
	FORINGIO = '7226',
	FRANCES = '7081',
	FRANCES_Y_OTROS_IDIOMAS = '7083',
	GEORGIANO = '7227',
	GRIEGO = '7091',
	GRIEGO_Y_OTROS_IDIOMAS = '7093',
	GUARANI = '5542',
	GUARIJIO = '0014',
	HEBREO = '7101',
	HEBREO_Y_OTROS_IDIOMAS = '7103',
	HINDU = '7111',
	HINDU_Y_OTROS_IDIOMAS = '7113',
	HOLANDES = '7121',
	HOLANDES_Y_OTROS_IDIOMAS = '7123',
	HUASTECO = '0050',
	HUAVE = '0075',
	HUICHOL = '0015',
	HUNGARO = '7228',
	INGLES = '7131',
	INGLES_LENGUA = '0083',
	INGLES_Y_OTROS_IDIOMAS = '7133',
	IRLANDES = '7230',
	ISLANDES = '7231',
	ITALIANO = '7141',
	ITALIANO_Y_OTROS_IDIOMAS = '7143',
	IXCATECO = '0036',
	IXIL = '0051',
	JAKALTEKO = '0052',
	JAPONES = '7151',
	JAPONES_Y_OTROS_IDIOMAS = '7153',
	KANJOBAL = '0961',
	KAQCHIKEL = '0054',
	KHMER = '7233',
	KICHE = '0053',
	KICKAPOOE = '0012',
	KILIWA = '0025',
	KUAHL = '0026',
	KUMIAI = '0027',
	LACANDON = '0055',
	LAO = '7237',
	LENGUAS_E_IDIOMAS_INSUFICIENTEMENTE_ESPECIFICADAS = '6000',
	LENGUAS_E_IDIOMAS_NO_ESPECIFICADAS = '9999',
	LETON = '7239',
	LITUANO = '7240',
	MALAYO = '7242',
	MAM = '0056',
	MAME = '0941',
	MANCHENO = '5075',
	MAORI = '7246',
	MATLATZINCA = '0037',
	MAYA = '0057',
	MAYO = '0016',
	MAZAHUA = '0038',
	MAZATECO = '0039',
	MIXE = '0069',
	MIXTECO = '0040',
	MONGOL = '7248',
	NAHUATL = '0017',
	NAURUANO = '7249',
	NEPALES = '7251',
	NORUEGO = '7254',
	OLUTECO = '0070',
	OTOMI = '0041',
	OTRAS_LENGUAS_INDIGENAS_DE_AMERICA = '5603',
	OTROS_IDIOMAS_EXTRANJEROS_NO_OFICIALES = '7285',
	PAIPAI = '0028',
	PAME = '0042',
	PAPAGO = '0018',
	PERSA = '7256',
	PIMA = '0019',
	POLACO = '7257',
	POPOLOCA = '0043',
	POPOLUCA_DE_LA_SIERRA = '0071',
	PORTUGUES = '7161',
	PORTUGUES_Y_OTROS_IDIOMAS = '7163',
	QANJOBAL = '0058',
	QATOK = '0060',
	QEQCHI = '0059',
	QUECHUA = '5551',
	RUMANO = '7258',
	RUSO = '7171',
	RUSO_Y_OTROS_IDIOMAS = '7173',
	SAMOANO = '7259',
	SAYULTECO = '0072',
	SERI = '0029',
	SESELWA = '7262',
	SIAMES = '7263',
	SUECO = '7268',
	SWAHILI = '7269',
	TARAHUMARA = '0020',
	TARASCO = '0067',
	TEKO = '0061',
	TEPEHUA = '0065',
	TEPEHUANO_DEL_NORTE = '0021',
	TEPEHUANO_DEL_SUR = '0022',
	TEXISTEPEQUENO = '0073',
	TLAHUICA = '0044',
	TLAPANECO = '0045',
	TOJOLABAL = '0062',
	TOTONACO = '0066',
	TRIQUI = '0078',
	TSELTAL = '0063',
	TSOTSIL = '0064',
	TURCO = '7181',
	TURCO_Y_OTROS_IDIOMAS = '7183',
	UCRANIANO = '7279',
	UZBEKO = '7280',
	VIETNAMITA = '7282',
	YAQUI = '0023',
	YUMA = '5601',
	ZAPOTECO = '0046',
	ZOQUE = '0079'
}
export const CIdiomas: Record<EIdiomas, string> = {
	[EIdiomas.ACALA]: 'ACALA',
	[EIdiomas.AKATEKO]: 'AKATEKO',
	[EIdiomas.ALBANES]: 'ALBANES',
	[EIdiomas.ALEMAN]: 'ALEMAN',
	[EIdiomas.ALEMAN_Y_OTROS_IDIOMAS]: 'ALEMAN Y OTRO(S) IDIOMA(S)',
	[EIdiomas.ALUSION_AL_MANEJO_DEL_CHECO]: 'ALUSION AL MANEJO DEL CHECO',
	[EIdiomas.ALUSION_AL_MANEJO_DEL_HOLANDES]: 'ALUSION AL MANEJO DEL HOLANDES',
	[EIdiomas.ALUSION_AL_MANEJO_DEL_INGLES]: 'ALUSION AL MANEJO DEL INGLES',
	[EIdiomas.ALUSION_AL_MANEJO_DEL_TURCO]: 'ALUSION AL MANEJO DEL TURCO',
	[EIdiomas.AMUZGO]: 'AMUZGO',
	[EIdiomas.ARABE]: 'ARABE',
	[EIdiomas.ARABE_Y_OTROS_IDIOMAS]: 'ARABE Y OTRO(S) IDIOMA(S)',
	[EIdiomas.AWAKATEKO]: 'AWAKATEKO',
	[EIdiomas.AYAPANECO]: 'AYAPANECO',
	[EIdiomas.BENGALI]: 'BENGALI',
	[EIdiomas.BIELORUSO]: 'BIELORUSO',
	[EIdiomas.BISLAMA]: 'BISLAMA',
	[EIdiomas.BULGARO]: 'BULGARO',
	[EIdiomas.CATALAN]: 'CATALAN',
	[EIdiomas.CHOL]: 'CH´OL',
	[EIdiomas.CHATINO]: 'CHATINO',
	[EIdiomas.CHECO]: 'CHECO',
	[EIdiomas.CHECO_Y_OTROS_IDIOMAS]: 'CHECO Y OTRO(S) IDIOMA(S)',
	[EIdiomas.CHEYENE]: 'CHEYENE',
	[EIdiomas.CHICHIMECO_JONAZ]: 'CHICHIMECO JONAZ',
	[EIdiomas.CHINANTECO]: 'CHINANTECO',
	[EIdiomas.CHINO]: 'CHINO',
	[EIdiomas.CHINO_CANTONES]: 'CHINO CANTONES',
	[EIdiomas.CHINO_CANTONES_Y_OTROS_IDIOMAS]: 'CHINO CANTONES Y OTRO(S) IDIOMA(S)',
	[EIdiomas.CHINO_MANDARIN]: 'CHINO MANDARIN',
	[EIdiomas.CHINO_MANDARIN_Y_OTROS_IDIOMAS]: 'CHINO MANDARIN Y OTRO(S) IDIOMA(S)',
	[EIdiomas.CHINO_Y_OTROS_IDIOMAS]: 'CHINO Y OTRO(S) IDIOMA(S)',
	[EIdiomas.CHOCHOLTECO]: 'CHOCHOLTECO',
	[EIdiomas.CHONTAL_DE_OAXACA]: 'CHONTAL DE OAXACA',
	[EIdiomas.CHONTAL_DE_TABASCO]: 'CHONTAL DE TABASCO',
	[EIdiomas.CHUJ]: 'CHUJ',
	[EIdiomas.CINGALES]: 'CINGALES',
	[EIdiomas.CORA]: 'CORA',
	[EIdiomas.COREANO]: 'COREANO',
	[EIdiomas.COREANO_Y_OTROS_IDIOMAS]: 'COREANO Y OTRO(S) IDIOMA(S)',
	[EIdiomas.CUCAPA]: 'CUCAPÁ',
	[EIdiomas.CUICATECO]: 'CUICATECO',
	[EIdiomas.DANES]: 'DANES',
	[EIdiomas.EMBERA]: 'EMBERA',
	[EIdiomas.ESLOVACO]: 'ESLOVACO',
	[EIdiomas.ESLOVENO]: 'ESLOVENO',
	[EIdiomas.ESPANOL]: 'ESPAÑOL',
	[EIdiomas.ESTONIO]: 'ESTONIO',
	[EIdiomas.FILIPINO]: 'FILIPINO',
	[EIdiomas.FINLANDES]: 'FINLANDES',
	[EIdiomas.FORINGIO]: 'FORINGIO',
	[EIdiomas.FRANCES]: 'FRANCES',
	[EIdiomas.FRANCES_Y_OTROS_IDIOMAS]: 'FRANCES Y OTRO(S) IDIOMA(S)',
	[EIdiomas.GEORGIANO]: 'GEORGIANO',
	[EIdiomas.GRIEGO]: 'GRIEGO',
	[EIdiomas.GRIEGO_Y_OTROS_IDIOMAS]: 'GRIEGO Y OTRO(S) IDIOMA(S)',
	[EIdiomas.GUARANI]: 'GUARANI',
	[EIdiomas.GUARIJIO]: 'GUARIJÍO',
	[EIdiomas.HEBREO]: 'HEBREO',
	[EIdiomas.HEBREO_Y_OTROS_IDIOMAS]: 'HEBREO Y OTRO(S) IDIOMA(S)',
	[EIdiomas.HINDU]: 'HINDU',
	[EIdiomas.HINDU_Y_OTROS_IDIOMAS]: 'HINDU Y OTRO(S) IDIOMA(S)',
	[EIdiomas.HOLANDES]: 'HOLANDES',
	[EIdiomas.HOLANDES_Y_OTROS_IDIOMAS]: 'HOLANDES Y OTRO(S) IDIOMA(S)',
	[EIdiomas.HUASTECO]: 'HUASTECO',
	[EIdiomas.HUAVE]: 'HUAVE',
	[EIdiomas.HUICHOL]: 'HUICHOL',
	[EIdiomas.HUNGARO]: 'HUNGARO',
	[EIdiomas.INGLES]: 'INGLES',
	[EIdiomas.INGLES_LENGUA]: 'INGLÉS',
	[EIdiomas.INGLES_Y_OTROS_IDIOMAS]: 'INGLES Y OTRO(S) IDIOMA(S)',
	[EIdiomas.IRLANDES]: 'IRLANDES',
	[EIdiomas.ISLANDES]: 'ISLANDES',
	[EIdiomas.ITALIANO]: 'ITALIANO',
	[EIdiomas.ITALIANO_Y_OTROS_IDIOMAS]: 'ITALIANO Y OTRO(S) IDIOMA(S)',
	[EIdiomas.IXCATECO]: 'IXCATECO',
	[EIdiomas.IXIL]: 'IXIL',
	[EIdiomas.JAKALTEKO]: 'JAKALTEKO',
	[EIdiomas.JAPONES]: 'JAPONES',
	[EIdiomas.JAPONES_Y_OTROS_IDIOMAS]: 'JAPONES Y OTRO(S) IDIOMA(S)',
	[EIdiomas.KANJOBAL]: 'KANJOBAL',
	[EIdiomas.KAQCHIKEL]: 'KAQCHIKEL',
	[EIdiomas.KHMER]: 'KHMER',
	[EIdiomas.KICHE]: 'K’ICHE’',
	[EIdiomas.KICKAPOOE]: 'KICKAPOOE',
	[EIdiomas.KILIWA]: 'KILIWA',
	[EIdiomas.KUAHL]: 'KU’AHL',
	[EIdiomas.KUMIAI]: 'KUMIAI',
	[EIdiomas.LACANDON]: 'LACANDÓN',
	[EIdiomas.LAO]: 'LAO',
	[EIdiomas.LENGUAS_E_IDIOMAS_INSUFICIENTEMENTE_ESPECIFICADAS]: 'LENGUAS E IDIOMAS INSUFICIENTEMENTE ESPECIFICADAS',
	[EIdiomas.LENGUAS_E_IDIOMAS_NO_ESPECIFICADAS]: 'LENGUAS E IDIOMAS NO ESPECIFICADAS',
	[EIdiomas.LETON]: 'LETON',
	[EIdiomas.LITUANO]: 'LITUANO',
	[EIdiomas.MALAYO]: 'MALAYO',
	[EIdiomas.MAM]: 'MAM',
	[EIdiomas.MAME]: 'MAME',
	[EIdiomas.MANCHENO]: 'MANCHEÑO',
	[EIdiomas.MAORI]: 'MAORI',
	[EIdiomas.MATLATZINCA]: 'MATLATZINCA',
	[EIdiomas.MAYA]: 'MAYA',
	[EIdiomas.MAYO]: 'MAYO',
	[EIdiomas.MAZAHUA]: 'MAZAHUA',
	[EIdiomas.MAZATECO]: 'MAZATECO',
	[EIdiomas.MIXE]: 'MIXE',
	[EIdiomas.MIXTECO]: 'MIXTECO',
	[EIdiomas.MONGOL]: 'MONGOL',
	[EIdiomas.NAHUATL]: 'NÁHUATL',
	[EIdiomas.NAURUANO]: 'NAURUANO',
	[EIdiomas.NEPALES]: 'NEPALES',
	[EIdiomas.NORUEGO]: 'NORUEGO',
	[EIdiomas.OLUTECO]: 'OLUTECO',
	[EIdiomas.OTOMI]: 'OTOMÍ',
	[EIdiomas.OTRAS_LENGUAS_INDIGENAS_DE_AMERICA]: 'OTRAS LENGUAS INDIGENAS DE AMERICA',
	[EIdiomas.OTROS_IDIOMAS_EXTRANJEROS_NO_OFICIALES]: 'OTROS IDIOMAS EXTRANJEROS NO OFICIALES',
	[EIdiomas.PAIPAI]: 'PAIPAI',
	[EIdiomas.PAME]: 'PAME',
	[EIdiomas.PAPAGO]: 'PÁPAGO',
	[EIdiomas.PERSA]: 'PERSA',
	[EIdiomas.PIMA]: 'PIMA',
	[EIdiomas.POLACO]: 'POLACO',
	[EIdiomas.POPOLOCA]: 'POPOLOCA',
	[EIdiomas.POPOLUCA_DE_LA_SIERRA]: 'POPOLUCA DE LA SIERRA',
	[EIdiomas.PORTUGUES]: 'PORTUGUES',
	[EIdiomas.PORTUGUES_Y_OTROS_IDIOMAS]: 'PORTUGUES Y OTRO(S) IDIOMA(S)',
	[EIdiomas.QANJOBAL]: 'Q’ANJOB’AL',
	[EIdiomas.QATOK]: 'QATO’K',
	[EIdiomas.QEQCHI]: 'Q’EQCHÍ’',
	[EIdiomas.QUECHUA]: 'QUECHUA',
	[EIdiomas.RUMANO]: 'RUMANO',
	[EIdiomas.RUSO]: 'RUSO',
	[EIdiomas.RUSO_Y_OTROS_IDIOMAS]: 'RUSO Y OTRO(S) IDIOMA(S)',
	[EIdiomas.SAMOANO]: 'SAMOANO',
	[EIdiomas.SAYULTECO]: 'SAYULTECO',
	[EIdiomas.SERI]: 'SERI',
	[EIdiomas.SESELWA]: 'SESELWA',
	[EIdiomas.SIAMES]: 'SIAMES',
	[EIdiomas.SUECO]: 'SUECO',
	[EIdiomas.SWAHILI]: 'SWAHILI',
	[EIdiomas.TARAHUMARA]: 'TARAHUMARA',
	[EIdiomas.TARASCO]: 'TARASCO',
	[EIdiomas.TEKO]: 'TEKO',
	[EIdiomas.TEPEHUA]: 'TEPEHUA',
	[EIdiomas.TEPEHUANO_DEL_NORTE]: 'TEPEHUANO DEL NORTE',
	[EIdiomas.TEPEHUANO_DEL_SUR]: 'TEPEHUANO DEL SUR',
	[EIdiomas.TEXISTEPEQUENO]: 'TEXISTEPEQUEÑO',
	[EIdiomas.TLAHUICA]: 'TLAHUICA',
	[EIdiomas.TLAPANECO]: 'TLAPANECO',
	[EIdiomas.TOJOLABAL]: 'TOJOLABAL',
	[EIdiomas.TOTONACO]: 'TOTONACO',
	[EIdiomas.TRIQUI]: 'TRIQUI',
	[EIdiomas.TSELTAL]: 'TSELTAL',
	[EIdiomas.TSOTSIL]: 'TSOTSIL',
	[EIdiomas.TURCO]: 'TURCO',
	[EIdiomas.TURCO_Y_OTROS_IDIOMAS]: 'TURCO Y OTRO(S) IDIOMA(S)',
	[EIdiomas.UCRANIANO]: 'UCRANIANO',
	[EIdiomas.UZBEKO]: 'UZBEKO',
	[EIdiomas.VIETNAMITA]: 'VIETNAMITA',
	[EIdiomas.YAQUI]: 'YAQUI',
	[EIdiomas.YUMA]: 'YUMA',
	[EIdiomas.ZAPOTECO]: 'ZAPOTECO',
	[EIdiomas.ZOQUE]: 'ZOQUE'
}
export enum ETurno {
	MATUTINO = 1,
	VESPERTINO = 2,
	MIXTO = 4,
	ABIERTO = 6
}
export const CTurno: Record<ETurno, string> = {
	[ETurno.MATUTINO]: 'MATUTINO',
	[ETurno.VESPERTINO]: 'VESPERTINO',
	[ETurno.MIXTO]: 'DISCONTINUO/MIXTO',
	[ETurno.ABIERTO]: 'ABIERTO'
}
export const CURP_CODIGO_ENTIDAD_FEDERATIVA: Record<string, EEntidadFederativa> = {
	AS: EEntidadFederativa.AGUASCALIENTES,
	BC: EEntidadFederativa.BAJA_CALIFORNIA,
	BS: EEntidadFederativa.BAJA_CALIFORNIA_SUR,
	CC: EEntidadFederativa.CAMPECHE,
	CL: EEntidadFederativa.COAHUILA_DE_ZARAGOZA,
	CM: EEntidadFederativa.COLIMA,
	CS: EEntidadFederativa.CHIAPAS,
	CH: EEntidadFederativa.CHIHUAHUA,
	DF: EEntidadFederativa.CIUDAD_DE_MEXICO,
	DG: EEntidadFederativa.DURANGO,
	GT: EEntidadFederativa.GUANAJUATO,
	GR: EEntidadFederativa.GUERRERO,
	HG: EEntidadFederativa.HIDALGO,
	JC: EEntidadFederativa.JALISCO,
	MC: EEntidadFederativa.MEXICO,
	MN: EEntidadFederativa.MICHOACAN_DE_OCAMPO,
	MS: EEntidadFederativa.MORELOS,
	NT: EEntidadFederativa.NAYARIT,
	NL: EEntidadFederativa.NUEVO_LEON,
	OC: EEntidadFederativa.OAXACA,
	PL: EEntidadFederativa.PUEBLA,
	QT: EEntidadFederativa.QUERETARO,
	QR: EEntidadFederativa.QUINTANA_ROO,
	SP: EEntidadFederativa.SAN_LUIS_POTOSI,
	SL: EEntidadFederativa.SINALOA,
	SR: EEntidadFederativa.SONORA,
	TC: EEntidadFederativa.TABASCO,
	TS: EEntidadFederativa.TAMAULIPAS,
	TL: EEntidadFederativa.TLAXCALA,
	VZ: EEntidadFederativa.VERACRUZ_DE_IGNACIO_DE_LA_LLAVE,
	YN: EEntidadFederativa.YUCATAN,
	ZS: EEntidadFederativa.ZACATECAS,
	NE: EEntidadFederativa.FORANEO
}
export enum EDuracionCarrera {
	DOS_ANIOS = 2,
	TRES_ANIOS = 3,
	CUATRO_ANIOS = 4,
	CINCO_ANIOS = 5,
	SEIS_ANIOS = 6
}
export const CDuracionCarrera: Record<EDuracionCarrera, string> = {
	[EDuracionCarrera.DOS_ANIOS]: '2 años',
	[EDuracionCarrera.TRES_ANIOS]: '3 años',
	[EDuracionCarrera.CUATRO_ANIOS]: '4 años',
	[EDuracionCarrera.CINCO_ANIOS]: '5 años',
	[EDuracionCarrera.SEIS_ANIOS]: '6 años'
}

export enum ECodigoError {
	A_NL_FLUJO = 'A_NL_FLUJO',
	A_NL_ANIOESCOLAR = 'A_NL_ANIOESCOLAR',
	A_NL_CICLOESCOLAR = 'A_NL_CICLOESCOLAR',
	A_NL_NOMBREALUMNO = 'A_NL_NOMBREALUMNO',
	A_NL_PRIMERAPELLIDOALUMNO = 'A_NL_PRIMERAPELLIDOALUMNO',
	A_NL_SEGUNDOAPELLIDOALUMNO = 'A_NL_SEGUNDOAPELLIDOALUMNO',
	A_NL_SEXO = 'A_NL_SEXO',
	A_NL_CURPALUMNO = 'A_NL_CURPALUMNO',
	A_NL_SEGMENTORAIZ = 'A_NL_SEGMENTORAIZ',
	A_NL_FECHANACIMIENTO = 'A_NL_FECHANACIMIENTO',
	A_NL_EMAILINSTITUCIONAL = 'A_NL_EMAILINSTITUCIONAL',
	A_NL_EMAILPERSONAL = 'A_NL_EMAILPERSONAL',
	A_NL_TEL_ALUMNO = 'A_NL_TEL_ALUMNO',
	A_NL_NACIONALIDAD = 'A_NL_NACIONALIDAD',
	A_NL_PAISNACIMIENTO = 'A_NL_PAISNACIMIENTO',
	A_NL_ENTIDADNACIMIENTO = 'A_NL_ENTIDADNACIMIENTO',
	A_NL_PAISRESIDENCIA = 'A_NL_PAISRESIDENCIA',
	A_NL_ENTIDADRESIDENCIA = 'A_NL_ENTIDADRESIDENCIA',
	A_NL_PAISPROCEDENCIA = 'A_NL_PAISPROCEDENCIA',
	A_NL_ENTIDADPROCEDENCIA = 'A_NL_ENTIDADPROCEDENCIA',
	A_NL_LENGUAMATERNA = 'A_NL_LENGUAMATERNA',
	A_NL_SEGUNDALENGUA = 'A_NL_SEGUNDALENGUA',
	A_NL_NECESIDADEDUCATIVA = 'A_NL_NECESIDADEDUCATIVA',
	A_NL_TIPODISCAPACIDAD = 'A_NL_TIPODISCAPACIDAD',
	A_NL_TIPOAPTITUDSOBRESALIENTE = 'A_NL_TIPOAPTITUDSOBRESALIENTE',
	A_NL_ID_INSTITUCION = 'A_NL_ID_INSTITUCION',
	A_NL_CCT = 'A_NL_CCT',
	A_NL_ID_CARRERA = 'A_NL_ID_CARRERA',
	A_NL_CREDITOSTOTALES_ES = 'A_NL_CREDITOSTOTALES_ES',
	A_NL_CREDITOSACUMULADOS_ES = 'A_NL_CREDITOSACUMULADOS_ES',
	A_NL_NIVELEDUCATIVO = 'A_NL_NIVELEDUCATIVO',
	A_NL_MODALIDAD = 'A_NL_MODALIDAD',
	A_NL_OPCIONEDUCATIVA = 'A_NL_OPCIONEDUCATIVA',
	A_NL_RVOE = 'A_NL_RVOE',
	A_NL_FECHARVOE = 'A_NL_FECHARVOE',
	A_NL_TURNO = 'A_NL_TURNO',
	A_NL_CICLOESCOLARINSTITUCIONAL = 'A_NL_CICLOESCOLARINSTITUCIONAL',
	A_NL_GRADO = 'A_NL_GRADO',
	A_NL_PERIODO = 'A_NL_PERIODO',
	A_NL_DURACIONPERIODOESCOLAR = 'A_NL_DURACIONPERIODOESCOLAR',
	A_NL_FECHAINICIOPERIODO = 'A_NL_FECHAINICIOPERIODO',
	A_NL_PRESENTADOCACADEMICA = 'A_NL_PRESENTADOCACADEMICA',
	A_NL_TIPODOCACADEMICA = 'A_NL_TIPODOCACADEMICA',
	A_NL_MATRICULA = 'A_NL_MATRICULA',
	A_NL_FECHAINICIOESTUDIOS = 'A_NL_FECHAINICIOESTUDIOS',
	A_NL_ORIGENESTUDIOSPROCEDENTE = 'A_NL_ORIGENESTUDIOSPROCEDENTE',
	A_NL_TIPOBAJASERVICIOEDUCATIVO = 'A_NL_TIPOBAJASERVICIOEDUCATIVO',
	A_NL_MOTIVOBAJA = 'A_NL_MOTIVOBAJA',
	A_IR_FLUJO = 'A_IR_FLUJO',
	A_IR_ANIOESCOLAR = 'A_IR_ANIOESCOLAR',
	A_IR_CICLOESCOLAR = 'A_IR_CICLOESCOLAR',
	A_IR_NOMBREALUMNO = 'A_IR_NOMBREALUMNO',
	A_IR_PRIMERAPELLIDOALUMNO = 'A_IR_PRIMERAPELLIDOALUMNO',
	A_IR_SEGUNDOAPELLIDOALUMNO = 'A_IR_SEGUNDOAPELLIDOALUMNO',
	A_IR_SEXO = 'A_IR_SEXO',
	A_IR_CURPALUMNO = 'A_IR_CURPALUMNO',
	A_IR_SEGMENTORAIZ = 'A_IR_SEGMENTORAIZ',
	A_IR_FECHANACIMIENTO = 'A_IR_FECHANACIMIENTO',
	A_IR_EMAILINSTITUCIONAL = 'A_IR_EMAILINSTITUCIONAL',
	A_IR_EMAILPERSONAL = 'A_IR_EMAILPERSONAL',
	A_IR_TEL_ALUMNO = 'A_IR_TEL_ALUMNO',
	A_IR_NACIONALIDAD = 'A_IR_NACIONALIDAD',
	A_IR_PAISNACIMIENTO = 'A_IR_PAISNACIMIENTO',
	A_IR_ENTIDADNACIMIENTO = 'A_IR_ENTIDADNACIMIENTO',
	A_IR_PAISRESIDENCIA = 'A_IR_PAISRESIDENCIA',
	A_IR_ENTIDADRESIDENCIA = 'A_IR_ENTIDADRESIDENCIA',
	A_IR_PAISPROCEDENCIA = 'A_IR_PAISPROCEDENCIA',
	A_IR_ENTIDADPROCEDENCIA = 'A_IR_ENTIDADPROCEDENCIA',
	A_IR_LENGUAMATERNA = 'A_IR_LENGUAMATERNA',
	A_IR_SEGUNDALENGUA = 'A_IR_SEGUNDALENGUA',
	A_IR_NECESIDADEDUCATIVA = 'A_IR_NECESIDADEDUCATIVA',
	A_IR_TIPODISCAPACIDAD = 'A_IR_TIPODISCAPACIDAD',
	A_IR_TIPOAPTITUDSOBRESALIENTE = 'A_IR_TIPOAPTITUDSOBRESALIENTE',
	A_IR_ID_INSTITUCION = 'A_IR_ID_INSTITUCION',
	A_IR_CCT = 'A_IR_CCT',
	A_IR_ID_CARRERA = 'A_IR_ID_CARRERA',
	A_IR_CREDITOSTOTALES_ES = 'A_IR_CREDITOSTOTALES_ES',
	A_IR_CREDITOSACUMULADOS_ES = 'A_IR_CREDITOSACUMULADOS_ES',
	A_IR_NIVELEDUCATIVO = 'A_IR_NIVELEDUCATIVO',
	A_IR_MODALIDAD = 'A_IR_MODALIDAD',
	A_IR_OPCIONEDUCATIVA = 'A_IR_OPCIONEDUCATIVA',
	A_IR_RVOE = 'A_IR_RVOE',
	A_IR_FECHARVOE = 'A_IR_FECHARVOE',
	A_IR_TURNO = 'A_IR_TURNO',
	A_IR_CICLOESCOLARINSTITUCIONAL = 'A_IR_CICLOESCOLARINSTITUCIONAL',
	A_IR_GRADO = 'A_IR_GRADO',
	A_IR_PERIODO = 'A_IR_PERIODO',
	A_IR_DURACIONPERIODOESCOLAR = 'A_IR_DURACIONPERIODOESCOLAR',
	A_IR_FECHAINICIOPERIODO = 'A_IR_FECHAINICIOPERIODO',
	A_IR_PRESENTADOCACADEMICA = 'A_IR_PRESENTADOCACADEMICA',
	A_IR_TIPODOCACADEMICA = 'A_IR_TIPODOCACADEMICA',
	A_IR_MATRICULA = 'A_IR_MATRICULA',
	A_IR_FECHAINICIOESTUDIOS = 'A_IR_FECHAINICIOESTUDIOS',
	A_IR_ORIGENESTUDIOSPROCEDENTE = 'A_IR_ORIGENESTUDIOSPROCEDENTE',
	A_IR_TIPOBAJASERVICIOEDUCATIVO = 'A_IR_TIPOBAJASERVICIOEDUCATIVO',
	A_IR_MOTIVOBAJA = 'A_IR_MOTIVOBAJA',
	A_WF_FLUJO = 'A_WF_FLUJO',
	A_WF_ANIOESCOLAR = 'A_WF_ANIOESCOLAR',
	A_WF_CICLOESCOLAR = 'A_WF_CICLOESCOLAR',
	A_WF_NOMBREALUMNO = 'A_WF_NOMBREALUMNO',
	A_WF_PRIMERAPELLIDOALUMNO = 'A_WF_PRIMERAPELLIDOALUMNO',
	A_WF_SEGUNDOAPELLIDOALUMNO = 'A_WF_SEGUNDOAPELLIDOALUMNO',
	A_WF_SEXO = 'A_WF_SEXO',
	A_WF_SEXO_CURP = 'A_WF_SEXO_CURP',
	A_WF_CURPALUMNO = 'A_WF_CURPALUMNO',
	A_WF_SEGMENTORAIZ = 'A_WF_SEGMENTORAIZ',
	A_WF_FECHANACIMIENTO = 'A_WF_FECHANACIMIENTO',
	A_WF_EMAILINSTITUCIONAL = 'A_WF_EMAILINSTITUCIONAL',
	A_WF_EMAILPERSONAL = 'A_WF_EMAILPERSONAL',
	A_WF_TEL_ALUMNO = 'A_WF_TEL_ALUMNO',
	A_WF_NACIONALIDAD = 'A_WF_NACIONALIDAD',
	A_WF_PAISNACIMIENTO = 'A_WF_PAISNACIMIENTO',
	A_WF_ENTIDADNACIMIENTO = 'A_WF_ENTIDADNACIMIENTO',
	A_WF_PAISRESIDENCIA = 'A_WF_PAISRESIDENCIA',
	A_WF_ENTIDADRESIDENCIA = 'A_WF_ENTIDADRESIDENCIA',
	A_WF_PAISPROCEDENCIA = 'A_WF_PAISPROCEDENCIA',
	A_WF_ENTIDADPROCEDENCIA = 'A_WF_ENTIDADPROCEDENCIA',
	A_WF_LENGUAMATERNA = 'A_WF_LENGUAMATERNA',
	A_WF_SEGUNDALENGUA = 'A_WF_SEGUNDALENGUA',
	A_WF_NECESIDADEDUCATIVA = 'A_WF_NECESIDADEDUCATIVA',
	A_WF_TIPODISCAPACIDAD = 'A_WF_TIPODISCAPACIDAD',
	A_WF_TIPOAPTITUDSOBRESALIENTE = 'A_WF_TIPOAPTITUDSOBRESALIENTE',
	A_WF_ID_INSTITUCION = 'A_WF_ID_INSTITUCION',
	A_WF_CCT = 'A_WF_CCT',
	A_WF_ID_CARRERA = 'A_WF_ID_CARRERA',
	A_WF_CREDITOSTOTALES_ES = 'A_WF_CREDITOSTOTALES_ES',
	A_WF_CREDITOSACUMULADOS_ES = 'A_WF_CREDITOSACUMULADOS_ES',
	A_WF_NIVELEDUCATIVO = 'A_WF_NIVELEDUCATIVO',
	A_WF_MODALIDAD = 'A_WF_MODALIDAD',
	A_WF_OPCIONEDUCATIVA = 'A_WF_OPCIONEDUCATIVA',
	A_WF_RVOE = 'A_WF_RVOE',
	A_WF_FECHARVOE = 'A_WF_FECHARVOE',
	A_WF_TURNO = 'A_WF_TURNO',
	A_WF_CICLOESCOLARINSTITUCIONAL = 'A_WF_CICLOESCOLARINSTITUCIONAL',
	A_WF_GRADO = 'A_WF_GRADO',
	A_WF_PERIODO = 'A_WF_PERIODO',
	A_WF_DURACIONPERIODOESCOLAR = 'A_WF_DURACIONPERIODOESCOLAR',
	A_WF_FECHAINICIOPERIODO = 'A_WF_FECHAINICIOPERIODO',
	A_WF_PRESENTADOCACADEMICA = 'A_WF_PRESENTADOCACADEMICA',
	A_WF_TIPODOCACADEMICA = 'A_WF_TIPODOCACADEMICA',
	A_WF_MATRICULA = 'A_WF_MATRICULA',
	A_WF_FECHAINICIOESTUDIOS = 'A_WF_FECHAINICIOESTUDIOS',
	A_WF_ORIGENESTUDIOSPROCEDENTE = 'A_WF_ORIGENESTUDIOSPROCEDENTE',
	A_WF_TIPOBAJASERVICIOEDUCATIVO = 'A_WF_TIPOBAJASERVICIOEDUCATIVO',
	A_WF_MOTIVOBAJA = 'A_WF_MOTIVOBAJA',
	A_L_FLUJO = 'A_L_FLUJO',
	A_L_ANIOESCOLAR = 'A_L_ANIOESCOLAR',
	A_L_CICLOESCOLAR = 'A_L_CICLOESCOLAR',
	A_L_NOMBREALUMNO = 'A_L_NOMBREALUMNO',
	A_L_PRIMERAPELLIDOALUMNO = 'A_L_PRIMERAPELLIDOALUMNO',
	A_L_SEGUNDOAPELLIDOALUMNO = 'A_L_SEGUNDOAPELLIDOALUMNO',
	A_L_SEXO = 'A_L_SEXO',
	A_L_CURPALUMNO = 'A_L_CURPALUMNO',
	A_L_SEGMENTORAIZ = 'A_L_SEGMENTORAIZ',
	A_L_FECHANACIMIENTO = 'A_L_FECHANACIMIENTO',
	A_L_EMAILINSTITUCIONAL = 'A_L_EMAILINSTITUCIONAL',
	A_L_EMAILPERSONAL = 'A_L_EMAILPERSONAL',
	A_L_TEL_ALUMNO = 'A_L_TEL_ALUMNO',
	A_L_NACIONALIDAD = 'A_L_NACIONALIDAD',
	A_L_PAISNACIMIENTO = 'A_L_PAISNACIMIENTO',
	A_L_ENTIDADNACIMIENTO = 'A_L_ENTIDADNACIMIENTO',
	A_L_PAISRESIDENCIA = 'A_L_PAISRESIDENCIA',
	A_L_ENTIDADRESIDENCIA = 'A_L_ENTIDADRESIDENCIA',
	A_L_PAISPROCEDENCIA = 'A_L_PAISPROCEDENCIA',
	A_L_ENTIDADPROCEDENCIA = 'A_L_ENTIDADPROCEDENCIA',
	A_L_LENGUAMATERNA = 'A_L_LENGUAMATERNA',
	A_L_SEGUNDALENGUA = 'A_L_SEGUNDALENGUA',
	A_L_NECESIDADEDUCATIVA = 'A_L_NECESIDADEDUCATIVA',
	A_L_TIPODISCAPACIDAD = 'A_L_TIPODISCAPACIDAD',
	A_L_TIPOAPTITUDSOBRESALIENTE = 'A_L_TIPOAPTITUDSOBRESALIENTE',
	A_L_ID_INSTITUCION = 'A_L_ID_INSTITUCION',
	A_L_CCT = 'A_L_CCT',
	A_L_ID_CARRERA = 'A_L_ID_CARRERA',
	A_L_CREDITOSTOTALES_ES = 'A_L_CREDITOSTOTALES_ES',
	A_L_CREDITOSACUMULADOS_ES = 'A_L_CREDITOSACUMULADOS_ES',
	A_L_NIVELEDUCATIVO = 'A_L_NIVELEDUCATIVO',
	A_L_MODALIDAD = 'A_L_MODALIDAD',
	A_L_OPCIONEDUCATIVA = 'A_L_OPCIONEDUCATIVA',
	A_L_RVOE = 'A_L_RVOE',
	A_L_FECHARVOE = 'A_L_FECHARVOE',
	A_L_TURNO = 'A_L_TURNO',
	A_L_CICLOESCOLARINSTITUCIONAL = 'A_L_CICLOESCOLARINSTITUCIONAL',
	A_L_GRADO = 'A_L_GRADO',
	A_L_PERIODO = 'A_L_PERIODO',
	A_L_DURACIONPERIODOESCOLAR = 'A_L_DURACIONPERIODOESCOLAR',
	A_L_FECHAINICIOPERIODO = 'A_L_FECHAINICIOPERIODO',
	A_L_PRESENTADOCACADEMICA = 'A_L_PRESENTADOCACADEMICA',
	A_L_TIPODOCACADEMICA = 'A_L_TIPODOCACADEMICA',
	A_L_MATRICULA = 'A_L_MATRICULA',
	A_L_FECHAINICIOESTUDIOS = 'A_L_FECHAINICIOESTUDIOS',
	A_L_ORIGENESTUDIOSPROCEDENTE = 'A_L_ORIGENESTUDIOSPROCEDENTE',
	A_L_TIPOBAJASERVICIOEDUCATIVO = 'A_L_TIPOBAJASERVICIOEDUCATIVO',
	A_L_MOTIVOBAJA = 'A_L_MOTIVOBAJA',
	A_CH_FLUJO = 'A_CH_FLUJO',
	A_CH_ANIOESCOLAR = 'A_CH_ANIOESCOLAR',
	A_CH_CICLOESCOLAR = 'A_CH_CICLOESCOLAR',
	A_CH_NOMBREALUMNO = 'A_CH_NOMBREALUMNO',
	A_CH_PRIMERAPELLIDOALUMNO = 'A_CH_PRIMERAPELLIDOALUMNO',
	A_CH_SEGUNDOAPELLIDOALUMNO = 'A_CH_SEGUNDOAPELLIDOALUMNO',
	A_CH_SEXO = 'A_CH_SEXO',
	A_CH_CURPALUMNO = 'A_CH_CURPALUMNO',
	A_CH_SEGMENTORAIZ = 'A_CH_SEGMENTORAIZ',
	A_CH_FECHANACIMIENTO = 'A_CH_FECHANACIMIENTO',
	A_CH_EMAILINSTITUCIONAL = 'A_CH_EMAILINSTITUCIONAL',
	A_CH_EMAILPERSONAL = 'A_CH_EMAILPERSONAL',
	A_CH_TEL_ALUMNO = 'A_CH_TEL_ALUMNO',
	A_CH_NACIONALIDAD = 'A_CH_NACIONALIDAD',
	A_CH_PAISNACIMIENTO = 'A_CH_PAISNACIMIENTO',
	A_CH_ENTIDADNACIMIENTO = 'A_CH_ENTIDADNACIMIENTO',
	A_CH_PAISRESIDENCIA = 'A_CH_PAISRESIDENCIA',
	A_CH_ENTIDADRESIDENCIA = 'A_CH_ENTIDADRESIDENCIA',
	A_CH_PAISPROCEDENCIA = 'A_CH_PAISPROCEDENCIA',
	A_CH_ENTIDADPROCEDENCIA = 'A_CH_ENTIDADPROCEDENCIA',
	A_CH_LENGUAMATERNA = 'A_CH_LENGUAMATERNA',
	A_CH_SEGUNDALENGUA = 'A_CH_SEGUNDALENGUA',
	A_CH_NECESIDADEDUCATIVA = 'A_CH_NECESIDADEDUCATIVA',
	A_CH_TIPODISCAPACIDAD = 'A_CH_TIPODISCAPACIDAD',
	A_CH_TIPOAPTITUDSOBRESALIENTE = 'A_CH_TIPOAPTITUDSOBRESALIENTE',
	A_CH_ID_INSTITUCION = 'A_CH_ID_INSTITUCION',
	A_CH_CCT = 'A_CH_CCT',
	A_CH_ID_CARRERA = 'A_CH_ID_CARRERA',
	A_CH_CREDITOSTOTALES_ES = 'A_CH_CREDITOSTOTALES_ES',
	A_CH_CREDITOSACUMULADOS_ES = 'A_CH_CREDITOSACUMULADOS_ES',
	A_CH_NIVELEDUCATIVO = 'A_CH_NIVELEDUCATIVO',
	A_CH_MODALIDAD = 'A_CH_MODALIDAD',
	A_CH_OPCIONEDUCATIVA = 'A_CH_OPCIONEDUCATIVA',
	A_CH_RVOE = 'A_CH_RVOE',
	A_CH_FECHARVOE = 'A_CH_FECHARVOE',
	A_CH_TURNO = 'A_CH_TURNO',
	A_CH_CICLOESCOLARINSTITUCIONAL = 'A_CH_CICLOESCOLARINSTITUCIONAL',
	A_CH_GRADO = 'A_CH_GRADO',
	A_CH_PERIODO = 'A_CH_PERIODO',
	A_CH_DURACIONPERIODOESCOLAR = 'A_CH_DURACIONPERIODOESCOLAR',
	A_CH_FECHAINICIOPERIODO = 'A_CH_FECHAINICIOPERIODO',
	A_CH_PRESENTADOCACADEMICA = 'A_CH_PRESENTADOCACADEMICA',
	A_CH_TIPODOCACADEMICA = 'A_CH_TIPODOCACADEMICA',
	A_CH_MATRICULA = 'A_CH_MATRICULA',
	A_CH_FECHAINICIOESTUDIOS = 'A_CH_FECHAINICIOESTUDIOS',
	A_CH_ORIGENESTUDIOSPROCEDENTE = 'A_CH_ORIGENESTUDIOSPROCEDENTE',
	A_CH_TIPOBAJASERVICIOEDUCATIVO = 'A_CH_TIPOBAJASERVICIOEDUCATIVO',
	A_CH_MOTIVOBAJA = 'A_CH_MOTIVOBAJA',
	A_NN_FLUJO = 'A_NN_FLUJO',
	A_NN_ANIOESCOLAR = 'A_NN_ANIOESCOLAR',
	A_NN_CICLOESCOLAR = 'A_NN_CICLOESCOLAR',
	A_NN_NOMBREALUMNO = 'A_NN_NOMBREALUMNO',
	A_NN_PRIMERAPELLIDOALUMNO = 'A_NN_PRIMERAPELLIDOALUMNO',
	A_NN_SEGUNDOAPELLIDOALUMNO = 'A_NN_SEGUNDOAPELLIDOALUMNO',
	A_NN_SEXO = 'A_NN_SEXO',
	A_NN_CURPALUMNO = 'A_NN_CURPALUMNO',
	A_NN_SEGMENTORAIZ = 'A_NN_SEGMENTORAIZ',
	A_NN_FECHANACIMIENTO = 'A_NN_FECHANACIMIENTO',
	A_NN_EMAILINSTITUCIONAL = 'A_NN_EMAILINSTITUCIONAL',
	A_NN_EMAILPERSONAL = 'A_NN_EMAILPERSONAL',
	A_NN_TEL_ALUMNO = 'A_NN_TEL_ALUMNO',
	A_NN_NACIONALIDAD = 'A_NN_NACIONALIDAD',
	A_NN_PAISNACIMIENTO = 'A_NN_PAISNACIMIENTO',
	A_NN_ENTIDADNACIMIENTO = 'A_NN_ENTIDADNACIMIENTO',
	A_NN_PAISRESIDENCIA = 'A_NN_PAISRESIDENCIA',
	A_NN_ENTIDADRESIDENCIA = 'A_NN_ENTIDADRESIDENCIA',
	A_NN_PAISPROCEDENCIA = 'A_NN_PAISPROCEDENCIA',
	A_NN_ENTIDADPROCEDENCIA = 'A_NN_ENTIDADPROCEDENCIA',
	A_NN_LENGUAMATERNA = 'A_NN_LENGUAMATERNA',
	A_NN_SEGUNDALENGUA = 'A_NN_SEGUNDALENGUA',
	A_NN_NECESIDADEDUCATIVA = 'A_NN_NECESIDADEDUCATIVA',
	A_NN_TIPODISCAPACIDAD = 'A_NN_TIPODISCAPACIDAD',
	A_NN_TIPOAPTITUDSOBRESALIENTE = 'A_NN_TIPOAPTITUDSOBRESALIENTE',
	A_NN_ID_INSTITUCION = 'A_NN_ID_INSTITUCION',
	A_NN_CCT = 'A_NN_CCT',
	A_NN_ID_CARRERA = 'A_NN_ID_CARRERA',
	A_NN_CREDITOSTOTALES_ES = 'A_NN_CREDITOSTOTALES_ES',
	A_NN_CREDITOSACUMULADOS_ES = 'A_NN_CREDITOSACUMULADOS_ES',
	A_NN_NIVELEDUCATIVO = 'A_NN_NIVELEDUCATIVO',
	A_NN_MODALIDAD = 'A_NN_MODALIDAD',
	A_NN_OPCIONEDUCATIVA = 'A_NN_OPCIONEDUCATIVA',
	A_NN_RVOE = 'A_NN_RVOE',
	A_NN_FECHARVOE = 'A_NN_FECHARVOE',
	A_NN_TURNO = 'A_NN_TURNO',
	A_NN_CICLOESCOLARINSTITUCIONAL = 'A_NN_CICLOESCOLARINSTITUCIONAL',
	A_NN_GRADO = 'A_NN_GRADO',
	A_NN_PERIODO = 'A_NN_PERIODO',
	A_NN_DURACIONPERIODOESCOLAR = 'A_NN_DURACIONPERIODOESCOLAR',
	A_NN_FECHAINICIOPERIODO = 'A_NN_FECHAINICIOPERIODO',
	A_NN_PRESENTADOCACADEMICA = 'A_NN_PRESENTADOCACADEMICA',
	A_NN_TIPODOCACADEMICA = 'A_NN_TIPODOCACADEMICA',
	A_NN_MATRICULA = 'A_NN_MATRICULA',
	A_NN_FECHAINICIOESTUDIOS = 'A_NN_FECHAINICIOESTUDIOS',
	A_NN_ORIGENESTUDIOSPROCEDENTE = 'A_NN_ORIGENESTUDIOSPROCEDENTE',
	A_NN_TIPOBAJASERVICIOEDUCATIVO = 'A_NN_TIPOBAJASERVICIOEDUCATIVO',
	A_NN_MOTIVOBAJA = 'A_NN_MOTIVOBAJA',
	A_IC_FLUJO = 'A_IC_FLUJO',
	A_IC_ANIOESCOLAR = 'A_IC_ANIOESCOLAR',
	A_IC_CICLOESCOLAR = 'A_IC_CICLOESCOLAR',
	A_IC_NOMBREALUMNO = 'A_IC_NOMBREALUMNO',
	A_IC_PRIMERAPELLIDOALUMNO = 'A_IC_PRIMERAPELLIDOALUMNO',
	A_IC_SEGUNDOAPELLIDOALUMNO = 'A_IC_SEGUNDOAPELLIDOALUMNO',
	A_IC_SEXO = 'A_IC_SEXO',
	A_IC_CURPALUMNO = 'A_IC_CURPALUMNO',
	A_IC_SEGMENTORAIZ = 'A_IC_SEGMENTORAIZ',
	A_IC_FECHANACIMIENTO = 'A_IC_FECHANACIMIENTO',
	A_IC_EMAILINSTITUCIONAL = 'A_IC_EMAILINSTITUCIONAL',
	A_IC_EMAILPERSONAL = 'A_IC_EMAILPERSONAL',
	A_IC_TEL_ALUMNO = 'A_IC_TEL_ALUMNO',
	A_IC_NACIONALIDAD = 'A_IC_NACIONALIDAD',
	A_IC_PAISNACIMIENTO = 'A_IC_PAISNACIMIENTO',
	A_IC_ENTIDADNACIMIENTO = 'A_IC_ENTIDADNACIMIENTO',
	A_IC_PAISRESIDENCIA = 'A_IC_PAISRESIDENCIA',
	A_IC_ENTIDADRESIDENCIA = 'A_IC_ENTIDADRESIDENCIA',
	A_IC_PAISPROCEDENCIA = 'A_IC_PAISPROCEDENCIA',
	A_IC_ENTIDADPROCEDENCIA = 'A_IC_ENTIDADPROCEDENCIA',
	A_IC_LENGUAMATERNA = 'A_IC_LENGUAMATERNA',
	A_IC_SEGUNDALENGUA = 'A_IC_SEGUNDALENGUA',
	A_IC_NECESIDADEDUCATIVA = 'A_IC_NECESIDADEDUCATIVA',
	A_IC_TIPODISCAPACIDAD = 'A_IC_TIPODISCAPACIDAD',
	A_IC_TIPOAPTITUDSOBRESALIENTE = 'A_IC_TIPOAPTITUDSOBRESALIENTE',
	A_IC_ID_INSTITUCION = 'A_IC_ID_INSTITUCION',
	A_IC_CCT = 'A_IC_CCT',
	A_IC_ID_CARRERA = 'A_IC_ID_CARRERA',
	A_IC_CREDITOSTOTALES_ES = 'A_IC_CREDITOSTOTALES_ES',
	A_IC_CREDITOSACUMULADOS_ES = 'A_IC_CREDITOSACUMULADOS_ES',
	A_IC_NIVELEDUCATIVO = 'A_IC_NIVELEDUCATIVO',
	A_IC_MODALIDAD = 'A_IC_MODALIDAD',
	A_IC_OPCIONEDUCATIVA = 'A_IC_OPCIONEDUCATIVA',
	A_IC_RVOE = 'A_IC_RVOE',
	A_IC_FECHARVOE = 'A_IC_FECHARVOE',
	A_IC_TURNO = 'A_IC_TURNO',
	A_IC_CICLOESCOLARINSTITUCIONAL = 'A_IC_CICLOESCOLARINSTITUCIONAL',
	A_IC_GRADO = 'A_IC_GRADO',
	A_IC_PERIODO = 'A_IC_PERIODO',
	A_IC_DURACIONPERIODOESCOLAR = 'A_IC_DURACIONPERIODOESCOLAR',
	A_IC_FECHAINICIOPERIODO = 'A_IC_FECHAINICIOPERIODO',
	A_IC_PRESENTADOCACADEMICA = 'A_IC_PRESENTADOCACADEMICA',
	A_IC_TIPODOCACADEMICA = 'A_IC_TIPODOCACADEMICA',
	A_IC_MATRICULA = 'A_IC_MATRICULA',
	A_IC_FECHAINICIOESTUDIOS = 'A_IC_FECHAINICIOESTUDIOS',
	A_IC_ORIGENESTUDIOSPROCEDENTE = 'A_IC_ORIGENESTUDIOSPROCEDENTE',
	A_IC_TIPOBAJASERVICIOEDUCATIVO = 'A_IC_TIPOBAJASERVICIOEDUCATIVO',
	A_IC_MOTIVOBAJA = 'A_IC_MOTIVOBAJA',
	A_IC_MODALIDADEDUCATIVA_OPCIONEDUCATIVA = 'A_IC_MODALIDADEDUCATIVA_OPCIONEDUCATIVA',
	A_SC_FLUJO = 'A_SC_FLUJO',
	A_SC_ANIOESCOLAR = 'A_SC_ANIOESCOLAR',
	A_SC_CICLOESCOLAR = 'A_SC_CICLOESCOLAR',
	A_SC_NOMBREALUMNO = 'A_SC_NOMBREALUMNO',
	A_SC_PRIMERAPELLIDOALUMNO = 'A_SC_PRIMERAPELLIDOALUMNO',
	A_SC_SEGUNDOAPELLIDOALUMNO = 'A_SC_SEGUNDOAPELLIDOALUMNO',
	A_SC_SEXO = 'A_SC_SEXO',
	A_SC_CURPALUMNO = 'A_SC_CURPALUMNO',
	A_SC_SEGMENTORAIZ = 'A_SC_SEGMENTORAIZ',
	A_SC_FECHANACIMIENTO = 'A_SC_FECHANACIMIENTO',
	A_SC_EMAILINSTITUCIONAL = 'A_SC_EMAILINSTITUCIONAL',
	A_SC_EMAILPERSONAL = 'A_SC_EMAILPERSONAL',
	A_SC_TEL_ALUMNO = 'A_SC_TEL_ALUMNO',
	A_SC_NACIONALIDAD = 'A_SC_NACIONALIDAD',
	A_SC_PAISNACIMIENTO = 'A_SC_PAISNACIMIENTO',
	A_SC_ENTIDADNACIMIENTO = 'A_SC_ENTIDADNACIMIENTO',
	A_SC_PAISRESIDENCIA = 'A_SC_PAISRESIDENCIA',
	A_SC_ENTIDADRESIDENCIA = 'A_SC_ENTIDADRESIDENCIA',
	A_SC_PAISPROCEDENCIA = 'A_SC_PAISPROCEDENCIA',
	A_SC_ENTIDADPROCEDENCIA = 'A_SC_ENTIDADPROCEDENCIA',
	A_SC_LENGUAMATERNA = 'A_SC_LENGUAMATERNA',
	A_SC_SEGUNDALENGUA = 'A_SC_SEGUNDALENGUA',
	A_SC_NECESIDADEDUCATIVA = 'A_SC_NECESIDADEDUCATIVA',
	A_SC_TIPODISCAPACIDAD = 'A_SC_TIPODISCAPACIDAD',
	A_SC_TIPOAPTITUDSOBRESALIENTE = 'A_SC_TIPOAPTITUDSOBRESALIENTE',
	A_SC_ID_INSTITUCION = 'A_SC_ID_INSTITUCION',
	A_SC_CCT = 'A_SC_CCT',
	A_SC_ID_CARRERA = 'A_SC_ID_CARRERA',
	A_SC_CREDITOSTOTALES_ES = 'A_SC_CREDITOSTOTALES_ES',
	A_SC_CREDITOSACUMULADOS_ES = 'A_SC_CREDITOSACUMULADOS_ES',
	A_SC_NIVELEDUCATIVO = 'A_SC_NIVELEDUCATIVO',
	A_SC_MODALIDAD = 'A_SC_MODALIDAD',
	A_SC_OPCIONEDUCATIVA = 'A_SC_OPCIONEDUCATIVA',
	A_SC_RVOE = 'A_SC_RVOE',
	A_SC_FECHARVOE = 'A_SC_FECHARVOE',
	A_SC_TURNO = 'A_SC_TURNO',
	A_SC_CICLOESCOLARINSTITUCIONAL = 'A_SC_CICLOESCOLARINSTITUCIONAL',
	A_SC_GRADO = 'A_SC_GRADO',
	A_SC_PERIODO = 'A_SC_PERIODO',
	A_SC_DURACIONPERIODOESCOLAR = 'A_SC_DURACIONPERIODOESCOLAR',
	A_SC_FECHAINICIOPERIODO = 'A_SC_FECHAINICIOPERIODO',
	A_SC_PRESENTADOCACADEMICA = 'A_SC_PRESENTADOCACADEMICA',
	A_SC_TIPODOCACADEMICA = 'A_SC_TIPODOCACADEMICA',
	A_SC_MATRICULA = 'A_SC_MATRICULA',
	A_SC_FECHAINICIOESTUDIOS = 'A_SC_FECHAINICIOESTUDIOS',
	A_SC_ORIGENESTUDIOSPROCEDENTE = 'A_SC_ORIGENESTUDIOSPROCEDENTE',
	A_SC_TIPOBAJASERVICIOEDUCATIVO = 'A_SC_TIPOBAJASERVICIOEDUCATIVO',
	A_SC_MOTIVOBAJA = 'A_SC_MOTIVOBAJA'
}
export const CCodigoError: Record<ECodigoError, string> = {
	[ECodigoError.A_NL_FLUJO]:
		'"Flujo" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja',
	[ECodigoError.A_NL_ANIOESCOLAR]:
		'"Año escolar" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_CICLOESCOLAR]:
		'"Ciclo Institucional" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_NOMBREALUMNO]:
		'"Nombre(s) del estudiante" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_PRIMERAPELLIDOALUMNO]:
		'"Primer Apellido" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_SEGUNDOAPELLIDOALUMNO]:
		'"Segundo Apellido" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_SEXO]:
		'"Sexo" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_CURPALUMNO]:
		'"CURP" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_SEGMENTORAIZ]:
		'"Segmento Raíz" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_FECHANACIMIENTO]:
		'"Fecha de nacimiento" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_EMAILINSTITUCIONAL]:
		'"Correo electrónico Institucional" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_EMAILPERSONAL]:
		'"Correo electrónico personal" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_TEL_ALUMNO]:
		'"ALUMNO" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_NACIONALIDAD]:
		'"Nacionalidad" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_PAISNACIMIENTO]:
		'"País de Nacimiento" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_ENTIDADNACIMIENTO]:
		'"Entidad de Nacimiento" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_PAISRESIDENCIA]:
		'"País de Residencia" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_ENTIDADRESIDENCIA]:
		'"Entidad de Residencia" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_PAISPROCEDENCIA]:
		'"País de Procedencia" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_ENTIDADPROCEDENCIA]:
		'"Entidad de Procedencia" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_LENGUAMATERNA]:
		'"Lengua materna" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_SEGUNDALENGUA]:
		'"Segunda lengua" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_NECESIDADEDUCATIVA]:
		'"Necesidad educativa" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_TIPODISCAPACIDAD]:
		'"Tipo de discapacidad" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_TIPOAPTITUDSOBRESALIENTE]:
		'"Tipo de aptitud sobresaliente" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_ID_INSTITUCION]:
		'"INSTITUCION" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_CCT]:
		'"Clave de la escuela" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_ID_CARRERA]:
		'"CARRERA" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_CREDITOSTOTALES_ES]:
		'"Creditos totales" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_CREDITOSACUMULADOS_ES]:
		'"Creditos acumulados" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_NIVELEDUCATIVO]:
		'"Nivel Educativo" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_MODALIDAD]:
		'"Modalidad educativa" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_OPCIONEDUCATIVA]:
		'"Opción Educativa" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_RVOE]:
		'"Número de Acuerdo de RVOE/ Acuerdo Secretarial/ Decreto Presidencial" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_FECHARVOE]:
		'"Fecha de Acuerdo del Número de Acuerdo de RVOE/ Acuerdo Secretarial/ Decreto Presidencial" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_TURNO]:
		'"Turno" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_CICLOESCOLARINSTITUCIONAL]:
		'"Ciclo Institucional" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_GRADO]:
		'"Grado de avance que cursa el estudiante del plan de estudios" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_PERIODO]:
		'"Periodo o Módulo escolar" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_DURACIONPERIODOESCOLAR]:
		'"Duración del periodo o módulo escolar del plan de estudios" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_FECHAINICIOPERIODO]:
		'"Fecha de inicio del periodo o módulo escolar reportado del plan de estudios" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_PRESENTADOCACADEMICA]:
		'"Antecedente Académico" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_TIPODOCACADEMICA]:
		'"Tipo de Antecedente Académico" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_MATRICULA]:
		'"Número de matrícula institucional o de control escolar del estudiante." viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_FECHAINICIOESTUDIOS]:
		'"Fecha de inició de estudios a primer ingreso de Educación Superior" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_ORIGENESTUDIOSPROCEDENTE]:
		'"Origen de estudios precedentes." viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_TIPOBAJASERVICIOEDUCATIVO]:
		'"Tipo de baja del servicio educativo" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_NL_MOTIVOBAJA]:
		'"Motivo de Baja" viene vacío y para este alumno es obligatorio. Captura el dato o revisa si el Flujo es el correcto: la obligatoriedad cambia entre Inscripción, Reinscripción y Baja.',
	[ECodigoError.A_IR_FLUJO]: 'El valor de "Flujo" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_ANIOESCOLAR]: 'El valor de "Año escolar" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_CICLOESCOLAR]: 'El valor de "Ciclo Institucional" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_NOMBREALUMNO]: 'El valor de "Nombre(s) del estudiante" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_PRIMERAPELLIDOALUMNO]: 'El valor de "Primer Apellido" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_SEGUNDOAPELLIDOALUMNO]: 'El valor de "Segundo Apellido" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_SEXO]: 'El valor de "Sexo" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_CURPALUMNO]: 'El valor de "CURP" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_SEGMENTORAIZ]: 'El valor de "Segmento Raíz" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_FECHANACIMIENTO]: 'El valor de "Fecha de nacimiento" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_EMAILINSTITUCIONAL]: 'El valor de "Correo electrónico Institucional" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_EMAILPERSONAL]: 'El valor de "Correo electrónico personal" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_TEL_ALUMNO]: 'El valor de "ALUMNO" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_NACIONALIDAD]: 'El valor de "Nacionalidad" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_PAISNACIMIENTO]: 'El valor de "País de Nacimiento" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_ENTIDADNACIMIENTO]: 'El valor de "Entidad de Nacimiento" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_PAISRESIDENCIA]: 'El valor de "País de Residencia" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_ENTIDADRESIDENCIA]: 'El valor de "Entidad de Residencia" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_PAISPROCEDENCIA]: 'El valor de "País de Procedencia" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_ENTIDADPROCEDENCIA]: 'El valor de "Entidad de Procedencia" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_LENGUAMATERNA]: 'El valor de "Lengua materna" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_SEGUNDALENGUA]: 'El valor de "Segunda lengua" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_NECESIDADEDUCATIVA]: 'El valor de "Necesidad educativa" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_TIPODISCAPACIDAD]: 'El valor de "Tipo de discapacidad" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_TIPOAPTITUDSOBRESALIENTE]:
		'El valor de "Tipo de aptitud sobresaliente" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_ID_INSTITUCION]: 'El valor de "INSTITUCION" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_CCT]: 'El valor de "Clave de la escuela" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_ID_CARRERA]: 'El valor de "CARRERA" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_CREDITOSTOTALES_ES]: 'El valor de "ES" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_CREDITOSACUMULADOS_ES]: 'El valor de "ES" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_NIVELEDUCATIVO]: 'El valor de "Nivel Educativo" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_MODALIDAD]: 'El valor de "Modalidad educativa" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_OPCIONEDUCATIVA]: 'El valor de "Opción Educativa" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_RVOE]:
		'El valor de "Número de Acuerdo de RVOE/ Acuerdo Secretarial/ Decreto Presidencial" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_FECHARVOE]:
		'El valor de "Fecha de Acuerdo del Número de Acuerdo de RVOE/ Acuerdo Secretarial/ Decreto Presidencial" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_TURNO]: 'El valor de "Turno" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_CICLOESCOLARINSTITUCIONAL]: 'El valor de "Ciclo Institucional" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_GRADO]:
		'El valor de "Grado de avance que cursa el estudiante del plan de estudios" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_PERIODO]: 'El valor de "Periodo o Módulo escolar" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_DURACIONPERIODOESCOLAR]:
		'El valor de "Duración del periodo o módulo escolar del plan de estudios" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_FECHAINICIOPERIODO]:
		'El valor de "Fecha de inicio del periodo o módulo escolar reportado del plan de estudios" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_PRESENTADOCACADEMICA]: 'El valor de "Antecedente Académico" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_TIPODOCACADEMICA]: 'El valor de "Tipo de Antecedente Académico" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_MATRICULA]:
		'El valor de "Número de matrícula institucional o de control escolar del estudiante." está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_FECHAINICIOESTUDIOS]:
		'El valor de "Fecha de inició de estudios a primer ingreso de Educación Superior" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_ORIGENESTUDIOSPROCEDENTE]:
		'El valor de "Origen de estudios precedentes." está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_TIPOBAJASERVICIOEDUCATIVO]:
		'El valor de "Tipo de baja del servicio educativo" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_IR_MOTIVOBAJA]: 'El valor de "Motivo de Baja" está fuera del rango permitido: es un número válido, pero demasiado alto o demasiado bajo para este campo.',
	[ECodigoError.A_WF_FLUJO]: '"Flujo" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_ANIOESCOLAR]:
		'"Año escolar" no tiene la forma que el portal espera (máscara: YYYY). No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_CICLOESCOLAR]: 'El Ciclo Institucional va en formato AÑO-CICLO con el año de 4 dígitos y un guion, por ejemplo "2026-1".',
	[ECodigoError.A_WF_NOMBREALUMNO]:
		'"Nombre(s) del estudiante" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_PRIMERAPELLIDOALUMNO]:
		'"Primer Apellido" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_SEGUNDOAPELLIDOALUMNO]:
		'"Segundo Apellido" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_SEXO]:
		'"Sexo" no tiene la forma que el portal espera (máscara: H, M u O). No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_SEXO_CURP]:
		'El Sexo capturado no coincide con el de la CURP (posición 11, la letra H o M). Tres causas posibles: (1) el Sexo está mal capturado; (2) la CURP es de otra persona, típico al arrastrar celdas en Excel; (3) capturaste Sexo "O", que la CURP no puede representar, así que el portal siempre lo marca. Nota: si la CURP entera está mal formada, este código sale junto con A_WF_CURPALUMNO — en ese caso corrige primero la CURP y este desaparece solo.',
	[ECodigoError.A_WF_CURPALUMNO]:
		'La CURP no cumple la estructura oficial de 18 posiciones. Las que más fallan: la posición 2 debe ser una vocal (A, E, I, O, U) o X, porque es la primera vocal interna del primer apellido; las posiciones 12 y 13 son la clave RENAPO del estado de nacimiento, que NO es la clave numérica del catálogo de Entidades (Querétaro es QT, Ciudad de México es DF, nacido en el extranjero es NE); y las posiciones 14 a 16 son consonantes, ahí no van vocales ni números. El validador local te dice exactamente cuál posición falló.',
	[ECodigoError.A_WF_SEGMENTORAIZ]:
		'"Segmento Raíz" no tiene la forma que el portal espera (máscara: \'XXXX999999XXXXXX\'). No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_FECHANACIMIENTO]:
		'La fecha de nacimiento no se pudo leer, o es imposible. Revisa tres cosas en este orden: (1) que esté como DD/MM/AAAA con año de 4 dígitos; (2) que el día exista en ese mes (no hay 31 de febrero ni 31 de abril); (3) que no sea de hoy ni futura, que casi siempre pasa por invertir el día y el año, o porque Excel reformateó la celda solo.',
	[ECodigoError.A_WF_EMAILINSTITUCIONAL]:
		'"Correo electrónico Institucional" no tiene la forma que el portal espera (máscara: XXXX@XXX.XXX). No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_EMAILPERSONAL]:
		'"Correo electrónico personal" no tiene la forma que el portal espera (máscara: XXXX@XXX.XXX). No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_TEL_ALUMNO]: '"Telefono del alumno". Revisa cuál de los dos está mal capturado para este alumno.',
	[ECodigoError.A_WF_NACIONALIDAD]:
		'"Nacionalidad" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_PAISNACIMIENTO]:
		'"País de Nacimiento" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_ENTIDADNACIMIENTO]:
		'"Entidad de Nacimiento" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_PAISRESIDENCIA]:
		'"País de Residencia" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_ENTIDADRESIDENCIA]:
		'"Entidad de Residencia" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_PAISPROCEDENCIA]:
		'"País de Procedencia" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_ENTIDADPROCEDENCIA]:
		'"Entidad de Procedencia" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_LENGUAMATERNA]:
		'"Lengua materna" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_SEGUNDALENGUA]:
		'"Segunda lengua" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_NECESIDADEDUCATIVA]:
		'"Necesidad educativa" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_TIPODISCAPACIDAD]:
		'"Tipo de discapacidad" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_TIPOAPTITUDSOBRESALIENTE]:
		'"Tipo de aptitud sobresaliente" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_ID_INSTITUCION]: '"ID Institución", Los datos no coinciden con los registros, Revisa cuál de los dos está mal capturado para este alumno.',
	[ECodigoError.A_WF_CCT]:
		'"Clave de la escuela" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_ID_CARRERA]: '"ID Carrera", Los datos no coinciden con los registros, Revisa cuál de los dos está mal capturado para este alumno.',
	[ECodigoError.A_WF_CREDITOSTOTALES_ES]:
		'"Créditos totales de la carrera de acuerdo con el plan y programa de estudios" y "ES" se contradicen entre sí. Los dos datos pueden ser correctos por separado: lo que el portal rechaza es la combinación. Revisa cuál de los dos está mal capturado para este alumno.',
	[ECodigoError.A_WF_CREDITOSACUMULADOS_ES]:
		'"CREDITOSACUMULADOS" y "ES" se contradicen entre sí. Los dos datos pueden ser correctos por separado: lo que el portal rechaza es la combinación. Revisa cuál de los dos está mal capturado para este alumno.',
	[ECodigoError.A_WF_NIVELEDUCATIVO]:
		'"Nivel Educativo" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_MODALIDAD]:
		'"Modalidad educativa" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_OPCIONEDUCATIVA]:
		'"Opción Educativa" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_RVOE]:
		'"Número de Acuerdo de RVOE/ Acuerdo Secretarial/ Decreto Presidencial" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_FECHARVOE]: 'La Fecha de Acuerdo de RVOE no se pudo leer. Debe ir como DD/MM/AAAA y existir en el calendario. Cópiala del acuerdo, no la deduzcas del ciclo escolar.',
	[ECodigoError.A_WF_TURNO]: '"Turno" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_CICLOESCOLARINSTITUCIONAL]:
		'"Ciclo Institucional" no tiene la forma que el portal espera (máscara: YYYY-99). No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_GRADO]:
		'"Grado de avance que cursa el estudiante del plan de estudios" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_PERIODO]:
		'"Periodo o Módulo escolar" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_DURACIONPERIODOESCOLAR]:
		'"Duración del periodo o módulo escolar del plan de estudios" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_FECHAINICIOPERIODO]:
		'La Fecha de inicio del periodo no se pudo leer, o no coincide con el periodo registrado. Debe ir como DD/MM/AAAA y existir en el calendario. Si el formato es correcto y aun así sale, revisa que la fecha sea la que el portal tiene dada de alta para ese ciclo y esa CCT.',
	[ECodigoError.A_WF_PRESENTADOCACADEMICA]:
		'"Antecedente Académico" no tiene la forma que el portal espera (máscara: S N). No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_TIPODOCACADEMICA]:
		'El campo "Antecedente Académico" dice "N" (no presentó), así que el "Tipo de Antecedente Académico" debe ir vacío. Deja vacío el tipo, o cambia el Antecedente a "S" si el alumno sí entregó el documento. Nota: esta regla está documentada en el layout pero el portal no la exigió en nuestras pruebas, así que puede aparecer solo en el validador local.',
	[ECodigoError.A_WF_MATRICULA]:
		'"Número de matrícula institucional o de control escolar del estudiante." no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_FECHAINICIOESTUDIOS]: 'La Fecha de inicio de estudios a primer ingreso no se pudo leer. Debe ir como DD/MM/AAAA y existir en el calendario.',
	[ECodigoError.A_WF_ORIGENESTUDIOSPROCEDENTE]:
		'"Origen de estudios precedentes." no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_TIPOBAJASERVICIOEDUCATIVO]:
		'"Tipo de baja del servicio educativo" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_WF_MOTIVOBAJA]:
		'"Motivo de Baja" no tiene la forma que el portal espera. No es que el valor no exista en un catálogo, es que está mal escrito: revisa longitud, separadores y caracteres raros.',
	[ECodigoError.A_L_FLUJO]: '"Flujo" no tiene la longitud correcta. Debe tener 1 carácter(es).',
	[ECodigoError.A_L_ANIOESCOLAR]: '"Año escolar" no tiene la longitud correcta. Debe tener 4 carácter(es).',
	[ECodigoError.A_L_CICLOESCOLAR]: '"Ciclo Institucional" no tiene la longitud correcta. Debe tener 50 carácter(es).',
	[ECodigoError.A_L_NOMBREALUMNO]: '"Nombre(s) del estudiante" no tiene la longitud correcta. Debe tener 100 carácter(es).',
	[ECodigoError.A_L_PRIMERAPELLIDOALUMNO]: '"Primer Apellido" no tiene la longitud correcta. Debe tener 100 carácter(es).',
	[ECodigoError.A_L_SEGUNDOAPELLIDOALUMNO]: '"Segundo Apellido" no tiene la longitud correcta. Debe tener 100 carácter(es).',
	[ECodigoError.A_L_SEXO]: '"Sexo" no tiene la longitud correcta. Debe tener 1 carácter(es).',
	[ECodigoError.A_L_CURPALUMNO]: '"CURP" no tiene la longitud correcta. Debe tener 18 carácter(es).',
	[ECodigoError.A_L_SEGMENTORAIZ]: '"Segmento Raíz" no tiene la longitud correcta. Debe tener 16 carácter(es).',
	[ECodigoError.A_L_FECHANACIMIENTO]: '"Fecha de nacimiento" no tiene la longitud correcta. Debe tener 10 carácter(es).',
	[ECodigoError.A_L_EMAILINSTITUCIONAL]: '"Correo electrónico Institucional" no tiene la longitud correcta. Debe tener 100 carácter(es).',
	[ECodigoError.A_L_EMAILPERSONAL]: '"Correo electrónico personal" no tiene la longitud correcta. Debe tener 100 carácter(es).',
	[ECodigoError.A_L_TEL_ALUMNO]: '"ALUMNO" no tiene la longitud correcta. Debe tener la longitud indicada en el layout.',
	[ECodigoError.A_L_NACIONALIDAD]: '"Nacionalidad" no tiene la longitud correcta. Debe tener 1 carácter(es).',
	[ECodigoError.A_L_PAISNACIMIENTO]: '"País de Nacimiento" no tiene la longitud correcta. Debe tener 3 carácter(es).',
	[ECodigoError.A_L_ENTIDADNACIMIENTO]: '"Entidad de Nacimiento" no tiene la longitud correcta. Debe tener 2 carácter(es).',
	[ECodigoError.A_L_PAISRESIDENCIA]: '"País de Residencia" no tiene la longitud correcta. Debe tener 3 carácter(es).',
	[ECodigoError.A_L_ENTIDADRESIDENCIA]: '"Entidad de Residencia" no tiene la longitud correcta. Debe tener 2 carácter(es).',
	[ECodigoError.A_L_PAISPROCEDENCIA]: '"País de Procedencia" no tiene la longitud correcta. Debe tener 3 carácter(es).',
	[ECodigoError.A_L_ENTIDADPROCEDENCIA]: '"Entidad de Procedencia" no tiene la longitud correcta. Debe tener 2 carácter(es).',
	[ECodigoError.A_L_LENGUAMATERNA]: '"Lengua materna" no tiene la longitud correcta. Debe tener 4 carácter(es).',
	[ECodigoError.A_L_SEGUNDALENGUA]: '"Segunda lengua" no tiene la longitud correcta. Debe tener 4 carácter(es).',
	[ECodigoError.A_L_NECESIDADEDUCATIVA]: '"Necesidad educativa" no tiene la longitud correcta. Debe tener 2 carácter(es).',
	[ECodigoError.A_L_TIPODISCAPACIDAD]: '"Tipo de discapacidad" no tiene la longitud correcta. Debe tener 2 carácter(es).',
	[ECodigoError.A_L_TIPOAPTITUDSOBRESALIENTE]: '"Tipo de aptitud sobresaliente" no tiene la longitud correcta. Debe tener 2 carácter(es).',
	[ECodigoError.A_L_ID_INSTITUCION]: '"INSTITUCION" no tiene la longitud correcta. Debe tener la longitud indicada en el layout.',
	[ECodigoError.A_L_CCT]: '"Clave de la escuela" no tiene la longitud correcta. Debe tener 10 carácter(es).',
	[ECodigoError.A_L_ID_CARRERA]: '"CARRERA" no tiene la longitud correcta. Debe tener la longitud indicada en el layout.',
	[ECodigoError.A_L_CREDITOSTOTALES_ES]: '"ES" no tiene la longitud correcta. Debe tener la longitud indicada en el layout.',
	[ECodigoError.A_L_CREDITOSACUMULADOS_ES]: '"ES" no tiene la longitud correcta. Debe tener la longitud indicada en el layout.',
	[ECodigoError.A_L_NIVELEDUCATIVO]: '"Nivel Educativo" no tiene la longitud correcta. Debe tener 2 carácter(es).',
	[ECodigoError.A_L_MODALIDAD]: '"Modalidad educativa" no tiene la longitud correcta. Debe tener 1 carácter(es).',
	[ECodigoError.A_L_OPCIONEDUCATIVA]: '"Opción Educativa" no tiene la longitud correcta. Debe tener 1 carácter(es).',
	[ECodigoError.A_L_RVOE]: '"Número de Acuerdo de RVOE/ Acuerdo Secretarial/ Decreto Presidencial" no tiene la longitud correcta. Debe tener 50 carácter(es).',
	[ECodigoError.A_L_FECHARVOE]: '"Fecha de Acuerdo del Número de Acuerdo de RVOE/ Acuerdo Secretarial/ Decreto Presidencial" no tiene la longitud correcta. Debe tener 10 carácter(es).',
	[ECodigoError.A_L_TURNO]: '"Turno" no tiene la longitud correcta. Debe tener 1 carácter(es).',
	[ECodigoError.A_L_CICLOESCOLARINSTITUCIONAL]: '"Ciclo Institucional" no tiene la longitud correcta. Debe tener 50 carácter(es).',
	[ECodigoError.A_L_GRADO]: '"Grado de avance que cursa el estudiante del plan de estudios" no tiene la longitud correcta. Debe tener 2 carácter(es).',
	[ECodigoError.A_L_PERIODO]: '"Periodo o Módulo escolar" no tiene la longitud correcta. Debe tener 2 carácter(es).',
	[ECodigoError.A_L_DURACIONPERIODOESCOLAR]: '"Duración del periodo o módulo escolar del plan de estudios" no tiene la longitud correcta. Debe tener 2 carácter(es).',
	[ECodigoError.A_L_FECHAINICIOPERIODO]: '"Fecha de inicio del periodo o módulo escolar reportado del plan de estudios" no tiene la longitud correcta. Debe tener 10 carácter(es).',
	[ECodigoError.A_L_PRESENTADOCACADEMICA]: '"Antecedente Académico" no tiene la longitud correcta. Debe tener 1 carácter(es).',
	[ECodigoError.A_L_TIPODOCACADEMICA]: '"Tipo de Antecedente Académico" no tiene la longitud correcta. Debe tener 2 carácter(es).',
	[ECodigoError.A_L_MATRICULA]: '"Número de matrícula institucional o de control escolar del estudiante." no tiene la longitud correcta. Debe tener 50 carácter(es).',
	[ECodigoError.A_L_FECHAINICIOESTUDIOS]: '"Fecha de inició de estudios a primer ingreso de Educación Superior" no tiene la longitud correcta. Debe tener 10 carácter(es).',
	[ECodigoError.A_L_ORIGENESTUDIOSPROCEDENTE]: '"Origen de estudios precedentes." no tiene la longitud correcta. Debe tener 2 carácter(es).',
	[ECodigoError.A_L_TIPOBAJASERVICIOEDUCATIVO]: '"Tipo de baja del servicio educativo" no tiene la longitud correcta. Debe tener 1 carácter(es).',
	[ECodigoError.A_L_MOTIVOBAJA]: '"Motivo de Baja" no tiene la longitud correcta. Debe tener 2 carácter(es).',
	[ECodigoError.A_CH_FLUJO]: '"Flujo" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_ANIOESCOLAR]: '"Año escolar" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_CICLOESCOLAR]:
		'"Ciclo Institucional" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_NOMBREALUMNO]:
		'"Nombre(s) del estudiante" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_PRIMERAPELLIDOALUMNO]:
		'"Primer Apellido" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_SEGUNDOAPELLIDOALUMNO]:
		'"Segundo Apellido" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_SEXO]: '"Sexo" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_CURPALUMNO]: '"CURP" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_SEGMENTORAIZ]: '"Segmento Raíz" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_FECHANACIMIENTO]:
		'"Fecha de nacimiento" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_EMAILINSTITUCIONAL]:
		'"Correo electrónico Institucional" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_EMAILPERSONAL]:
		'"Correo electrónico personal" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_TEL_ALUMNO]: '"ALUMNO" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_NACIONALIDAD]: '"Nacionalidad" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_PAISNACIMIENTO]:
		'"País de Nacimiento" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_ENTIDADNACIMIENTO]:
		'"Entidad de Nacimiento" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_PAISRESIDENCIA]:
		'"País de Residencia" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_ENTIDADRESIDENCIA]:
		'"Entidad de Residencia" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_PAISPROCEDENCIA]:
		'"País de Procedencia" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_ENTIDADPROCEDENCIA]:
		'"Entidad de Procedencia" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_LENGUAMATERNA]: '"Lengua materna" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_SEGUNDALENGUA]: '"Segunda lengua" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_NECESIDADEDUCATIVA]:
		'"Necesidad educativa" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_TIPODISCAPACIDAD]:
		'"Tipo de discapacidad" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_TIPOAPTITUDSOBRESALIENTE]:
		'"Tipo de aptitud sobresaliente" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_ID_INSTITUCION]: '"INSTITUCION" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_CCT]: '"Clave de la escuela" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_ID_CARRERA]: '"CARRERA" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_CREDITOSTOTALES_ES]: '"ES" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_CREDITOSACUMULADOS_ES]: '"ES" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_NIVELEDUCATIVO]:
		'"Nivel Educativo" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_MODALIDAD]:
		'"Modalidad educativa" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_OPCIONEDUCATIVA]:
		'"Opción Educativa" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_RVOE]:
		'"Número de Acuerdo de RVOE/ Acuerdo Secretarial/ Decreto Presidencial" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_FECHARVOE]:
		'"Fecha de Acuerdo del Número de Acuerdo de RVOE/ Acuerdo Secretarial/ Decreto Presidencial" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_TURNO]: '"Turno" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_CICLOESCOLARINSTITUCIONAL]:
		'"Ciclo Institucional" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_GRADO]:
		'"Grado de avance que cursa el estudiante del plan de estudios" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_PERIODO]:
		'"Periodo o Módulo escolar" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_DURACIONPERIODOESCOLAR]:
		'"Duración del periodo o módulo escolar del plan de estudios" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_FECHAINICIOPERIODO]:
		'"Fecha de inicio del periodo o módulo escolar reportado del plan de estudios" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_PRESENTADOCACADEMICA]:
		'"Antecedente Académico" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_TIPODOCACADEMICA]:
		'"Tipo de Antecedente Académico" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_MATRICULA]:
		'"Número de matrícula institucional o de control escolar del estudiante." trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_FECHAINICIOESTUDIOS]:
		'"Fecha de inició de estudios a primer ingreso de Educación Superior" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_ORIGENESTUDIOSPROCEDENTE]:
		'"Origen de estudios precedentes." trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_TIPOBAJASERVICIOEDUCATIVO]:
		'"Tipo de baja del servicio educativo" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_CH_MOTIVOBAJA]: '"Motivo de Baja" trae un carácter que el portal no acepta. Los sospechosos habituales: acentos, eñes, comillas curvas de Word, guiones largos y espacios dobles.',
	[ECodigoError.A_NN_FLUJO]: '"Flujo" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_ANIOESCOLAR]: '"Año escolar" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_CICLOESCOLAR]: '"Ciclo Institucional" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_NOMBREALUMNO]: '"Nombre(s) del estudiante" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_PRIMERAPELLIDOALUMNO]: '"Primer Apellido" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_SEGUNDOAPELLIDOALUMNO]: '"Segundo Apellido" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_SEXO]: '"Sexo" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_CURPALUMNO]: '"CURP" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_SEGMENTORAIZ]: '"Segmento Raíz" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_FECHANACIMIENTO]: '"Fecha de nacimiento" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_EMAILINSTITUCIONAL]: '"Correo electrónico Institucional" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_EMAILPERSONAL]: '"Correo electrónico personal" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_TEL_ALUMNO]: '"ALUMNO" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_NACIONALIDAD]: '"Nacionalidad" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_PAISNACIMIENTO]: '"País de Nacimiento" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_ENTIDADNACIMIENTO]: '"Entidad de Nacimiento" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_PAISRESIDENCIA]: '"País de Residencia" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_ENTIDADRESIDENCIA]: '"Entidad de Residencia" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_PAISPROCEDENCIA]: '"País de Procedencia" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_ENTIDADPROCEDENCIA]: '"Entidad de Procedencia" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_LENGUAMATERNA]: '"Lengua materna" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_SEGUNDALENGUA]: '"Segunda lengua" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_NECESIDADEDUCATIVA]: '"Necesidad educativa" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_TIPODISCAPACIDAD]: '"Tipo de discapacidad" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_TIPOAPTITUDSOBRESALIENTE]: '"Tipo de aptitud sobresaliente" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_ID_INSTITUCION]: '"INSTITUCION" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_CCT]: '"Clave de la escuela" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_ID_CARRERA]: '"CARRERA" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_CREDITOSTOTALES_ES]: '"ES" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_CREDITOSACUMULADOS_ES]: '"ES" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_NIVELEDUCATIVO]: '"Nivel Educativo" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_MODALIDAD]: '"Modalidad educativa" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_OPCIONEDUCATIVA]: '"Opción Educativa" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_RVOE]: '"Número de Acuerdo de RVOE/ Acuerdo Secretarial/ Decreto Presidencial" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_FECHARVOE]: '"Fecha de Acuerdo del Número de Acuerdo de RVOE/ Acuerdo Secretarial/ Decreto Presidencial" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_TURNO]: '"Turno" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_CICLOESCOLARINSTITUCIONAL]: '"Ciclo Institucional" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_GRADO]: '"Grado de avance que cursa el estudiante del plan de estudios" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_PERIODO]: '"Periodo o Módulo escolar" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_DURACIONPERIODOESCOLAR]: '"Duración del periodo o módulo escolar del plan de estudios" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_FECHAINICIOPERIODO]: '"Fecha de inicio del periodo o módulo escolar reportado del plan de estudios" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_PRESENTADOCACADEMICA]: '"Antecedente Académico" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_TIPODOCACADEMICA]: '"Tipo de Antecedente Académico" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_MATRICULA]: '"Número de matrícula institucional o de control escolar del estudiante." solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_FECHAINICIOESTUDIOS]: '"Fecha de inició de estudios a primer ingreso de Educación Superior" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_ORIGENESTUDIOSPROCEDENTE]: '"Origen de estudios precedentes." solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_TIPOBAJASERVICIOEDUCATIVO]: '"Tipo de baja del servicio educativo" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_NN_MOTIVOBAJA]: '"Motivo de Baja" solo admite dígitos. Quita cualquier letra o símbolo.',
	[ECodigoError.A_IC_FLUJO]:
		'El valor capturado en "Flujo" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: I) Inscripción | R) Reinscripción | B) Baja',
	[ECodigoError.A_IC_ANIOESCOLAR]:
		'El valor capturado en "Año escolar" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_CICLOESCOLAR]:
		'El valor capturado en "Ciclo Institucional" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_NOMBREALUMNO]:
		'El valor capturado en "Nombre(s) del estudiante" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_PRIMERAPELLIDOALUMNO]:
		'El valor capturado en "Primer Apellido" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_SEGUNDOAPELLIDOALUMNO]:
		'El valor capturado en "Segundo Apellido" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_SEXO]:
		'El valor capturado en "Sexo" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: H) Hombre | M) Mujer | O) Otro',
	[ECodigoError.A_IC_CURPALUMNO]:
		'El valor capturado en "CURP" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_SEGMENTORAIZ]:
		'El valor capturado en "Segmento Raíz" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_FECHANACIMIENTO]:
		'El valor capturado en "Fecha de nacimiento" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_EMAILINSTITUCIONAL]:
		'El valor capturado en "Correo electrónico Institucional" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_EMAILPERSONAL]:
		'El valor capturado en "Correo electrónico personal" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_TEL_ALUMNO]:
		'La combinación de "TEL" con "ALUMNO" no existe en el catálogo. Cada valor puede ser válido por su cuenta, pero no van juntos: revisa cuál de los dos corresponde de verdad a este alumno.',
	[ECodigoError.A_IC_NACIONALIDAD]:
		'El valor capturado en "Nacionalidad" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: 1) MEXICANO | 2) EXTRANJERO',
	[ECodigoError.A_IC_PAISNACIMIENTO]:
		'El valor capturado en "País de Nacimiento" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: Ver catálogo de Países',
	[ECodigoError.A_IC_ENTIDADNACIMIENTO]:
		'El valor capturado en "Entidad de Nacimiento" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: Ver catálogo de Entidades',
	[ECodigoError.A_IC_PAISRESIDENCIA]:
		'El valor capturado en "País de Residencia" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: Ver catálogo de Países',
	[ECodigoError.A_IC_ENTIDADRESIDENCIA]:
		'La Entidad de Residencia no existe (las claves van de 01 a 96) o no corresponde al País de Residencia. La clave depende del país: 01 a 32 México, 33 a 82 Estados Unidos, 83 a 95 Canadá, y 96 (Foráneo) para cualquier otro país. La 96 funciona con todos MENOS México.',
	[ECodigoError.A_IC_PAISPROCEDENCIA]:
		'El valor capturado en "País de Procedencia" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: Ver catálogo de Países',
	[ECodigoError.A_IC_ENTIDADPROCEDENCIA]:
		'La Entidad de Procedencia no existe (las claves van de 01 a 96) o no corresponde al País de Procedencia. La clave depende del país: 01 a 32 México, 33 a 82 Estados Unidos, 83 a 95 Canadá, y 96 (Foráneo) para cualquier otro país. La 96 funciona con todos MENOS México.',
	[ECodigoError.A_IC_LENGUAMATERNA]:
		'El valor capturado en "Lengua materna" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_SEGUNDALENGUA]:
		'El valor capturado en "Segunda lengua" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_NECESIDADEDUCATIVA]:
		'El valor capturado en "Necesidad educativa" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: 00) No Aplica/Se desconoce | 01) Discapacidad | 02) Aptitud Sobresaliente',
	[ECodigoError.A_IC_TIPODISCAPACIDAD]: 'Marcaste Necesidad educativa "01 Discapacidad" pero falta especificar cuál es, o la clave capturada no existe en el catálogo (van del 1 al 15).',
	[ECodigoError.A_IC_TIPOAPTITUDSOBRESALIENTE]:
		'Marcaste Necesidad educativa "02 Aptitud Sobresaliente" pero falta especificar cuál es, o la clave capturada no existe en el catálogo (1 a 5, más la 12 para "cualquier otra").',
	[ECodigoError.A_IC_ID_INSTITUCION]:
		'La combinación de "ID" con "INSTITUCION" no existe en el catálogo. Cada valor puede ser válido por su cuenta, pero no van juntos: revisa cuál de los dos corresponde de verdad a este alumno.',
	[ECodigoError.A_IC_CCT]:
		'El valor capturado en "Clave de la escuela" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_ID_CARRERA]:
		'La combinación de "ID" con "CARRERA" no existe en el catálogo. Cada valor puede ser válido por su cuenta, pero no van juntos: revisa cuál de los dos corresponde de verdad a este alumno.',
	[ECodigoError.A_IC_CREDITOSTOTALES_ES]:
		'La combinación de "Créditos totales de la carrera de acuerdo con el plan y programa de estudios" con "ES" no existe en el catálogo. Cada valor puede ser válido por su cuenta, pero no van juntos: revisa cuál de los dos corresponde de verdad a este alumno.',
	[ECodigoError.A_IC_CREDITOSACUMULADOS_ES]:
		'La combinación de "CREDITOSACUMULADOS" con "ES" no existe en el catálogo. Cada valor puede ser válido por su cuenta, pero no van juntos: revisa cuál de los dos corresponde de verdad a este alumno.',
	[ECodigoError.A_IC_NIVELEDUCATIVO]:
		'El valor capturado en "Nivel Educativo" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: 83) Profesional Asociado | 84) Técnico Superior Universitario  | 81) Licenciatura | 85) Especialidad | 82) Maestría | 95) Doctorado',
	[ECodigoError.A_IC_MODALIDAD]:
		'El valor capturado en "Modalidad educativa" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: 1) Escolarizada | 2) No escolarizada | 3) Mixta | 4) Dual',
	[ECodigoError.A_IC_OPCIONEDUCATIVA]:
		'El valor capturado en "Opción Educativa" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: Presencial | En línea/virtual | Abierta/a distancia | Certificación por examen | Dual',
	[ECodigoError.A_IC_RVOE]:
		'El número de RVOE no aparece en el catálogo oficial. Cópialo tal cual viene en el acuerdo: lo más común es que se hayan perdido los ceros a la izquierda o los guiones al pasarlo a Excel.',
	[ECodigoError.A_IC_FECHARVOE]:
		'El valor capturado en "Fecha de Acuerdo del Número de Acuerdo de RVOE/ Acuerdo Secretarial/ Decreto Presidencial" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_TURNO]:
		'El valor capturado en "Turno" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: 1) Matutino | 2) Verpertino | 4) Discontinuo/Mixto | 6) Abierto',
	[ECodigoError.A_IC_CICLOESCOLARINSTITUCIONAL]:
		'El valor capturado en "Ciclo Institucional" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_GRADO]:
		'El valor capturado en "Grado de avance que cursa el estudiante del plan de estudios" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: Tabla de equivalencias en el grado de avance',
	[ECodigoError.A_IC_PERIODO]:
		'El valor capturado en "Periodo o Módulo escolar" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: Catálogo número de periodo o módulo escolar',
	[ECodigoError.A_IC_DURACIONPERIODOESCOLAR]:
		'El valor capturado en "Duración del periodo o módulo escolar del plan de estudios" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: Catálogo de Periodos o módulo escolar',
	[ECodigoError.A_IC_FECHAINICIOPERIODO]:
		'El valor capturado en "Fecha de inicio del periodo o módulo escolar reportado del plan de estudios" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_PRESENTADOCACADEMICA]:
		'El valor capturado en "Antecedente Académico" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: S) Si | N) No',
	[ECodigoError.A_IC_TIPODOCACADEMICA]:
		'El valor capturado en "Tipo de Antecedente Académico" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: Catálogo de tipo de antecedente académico',
	[ECodigoError.A_IC_MATRICULA]:
		'El valor capturado en "Número de matrícula institucional o de control escolar del estudiante." no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_FECHAINICIOESTUDIOS]:
		'El valor capturado en "Fecha de inició de estudios a primer ingreso de Educación Superior" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial.',
	[ECodigoError.A_IC_ORIGENESTUDIOSPROCEDENTE]:
		'El valor capturado en "Origen de estudios precedentes." no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: 02) Nacionales | 03) Extranjeros',
	[ECodigoError.A_IC_TIPOBAJASERVICIOEDUCATIVO]:
		'El valor capturado en "Tipo de baja del servicio educativo" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: 1) Baja temporal | 2) Baja definitiva',
	[ECodigoError.A_IC_MOTIVOBAJA]:
		'El valor capturado en "Motivo de Baja" no existe en el catálogo. Casi siempre es por los ceros a la izquierda (el portal pide "01", no "1") o porque se usó una clave interna de la institución en lugar de la clave oficial. Valores válidos: Catálogo de Tipos de baja',
	[ECodigoError.A_IC_MODALIDADEDUCATIVA_OPCIONEDUCATIVA]:
		'La Opción Educativa no pertenece a la Modalidad capturada. Las únicas combinaciones válidas son: Modalidad 1 (Escolarizada) con Opción 1; Modalidad 2 (No escolarizada) con Opción 2, 3 o 4; Modalidad 3 (Mixta) con Opción 5, 6 u 8; Modalidad 4 (Dual) con Opción 7. Empieza por definir cuál es la Modalidad real del programa y de ahí escoge la Opción.',
	[ECodigoError.A_SC_FLUJO]: '"Flujo" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_ANIOESCOLAR]: '"Año escolar" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_CICLOESCOLAR]: '"Ciclo Institucional" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_NOMBREALUMNO]: '"Nombre(s) del estudiante" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_PRIMERAPELLIDOALUMNO]: '"Primer Apellido" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_SEGUNDOAPELLIDOALUMNO]: '"Segundo Apellido" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_SEXO]: '"Sexo" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_CURPALUMNO]: '"CURP" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_SEGMENTORAIZ]: '"Segmento Raíz" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_FECHANACIMIENTO]: '"Fecha de nacimiento" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_EMAILINSTITUCIONAL]: '"Correo electrónico Institucional" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_EMAILPERSONAL]: '"Correo electrónico personal" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_TEL_ALUMNO]: '"ALUMNO" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_NACIONALIDAD]: '"Nacionalidad" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_PAISNACIMIENTO]: '"País de Nacimiento" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_ENTIDADNACIMIENTO]: '"Entidad de Nacimiento" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_PAISRESIDENCIA]: '"País de Residencia" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_ENTIDADRESIDENCIA]: '"Entidad de Residencia" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_PAISPROCEDENCIA]: '"País de Procedencia" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_ENTIDADPROCEDENCIA]: '"Entidad de Procedencia" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_LENGUAMATERNA]: '"Lengua materna" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_SEGUNDALENGUA]: '"Segunda lengua" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_NECESIDADEDUCATIVA]: '"Necesidad educativa" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_TIPODISCAPACIDAD]: '"Tipo de discapacidad" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_TIPOAPTITUDSOBRESALIENTE]: '"Tipo de aptitud sobresaliente" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_ID_INSTITUCION]: '"INSTITUCION" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_CCT]: '"Clave de la escuela" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_ID_CARRERA]: '"CARRERA" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_CREDITOSTOTALES_ES]: '"ES" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_CREDITOSACUMULADOS_ES]: '"ES" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_NIVELEDUCATIVO]: '"Nivel Educativo" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_MODALIDAD]: '"Modalidad educativa" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_OPCIONEDUCATIVA]: '"Opción Educativa" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_RVOE]: '"Número de Acuerdo de RVOE/ Acuerdo Secretarial/ Decreto Presidencial" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_FECHARVOE]:
		'"Fecha de Acuerdo del Número de Acuerdo de RVOE/ Acuerdo Secretarial/ Decreto Presidencial" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_TURNO]: '"Turno" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_CICLOESCOLARINSTITUCIONAL]: '"Ciclo Institucional" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_GRADO]: '"Grado de avance que cursa el estudiante del plan de estudios" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_PERIODO]: '"Periodo o Módulo escolar" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_DURACIONPERIODOESCOLAR]:
		'"Duración del periodo o módulo escolar del plan de estudios" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_FECHAINICIOPERIODO]:
		'"Fecha de inicio del periodo o módulo escolar reportado del plan de estudios" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_PRESENTADOCACADEMICA]: '"Antecedente Académico" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_TIPODOCACADEMICA]: '"Tipo de Antecedente Académico" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_MATRICULA]:
		'"Número de matrícula institucional o de control escolar del estudiante." trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_FECHAINICIOESTUDIOS]:
		'"Fecha de inició de estudios a primer ingreso de Educación Superior" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_ORIGENESTUDIOSPROCEDENTE]: '"Origen de estudios precedentes." trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_TIPOBAJASERVICIOEDUCATIVO]: '"Tipo de baja del servicio educativo" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.',
	[ECodigoError.A_SC_MOTIVOBAJA]: '"Motivo de Baja" trae un carácter especial no permitido. Revisa acentos, comillas y símbolos copiados desde Word.'
}
export enum ENivelEstudio {
	DOCTORADO = 95,
	ESPECIALIDAD = 85,
	TECNICO_SUPERIOR_UNIVERSITARIO = 84,
	PROFESIONAL_ASOCIADO = 83,
	MAESTRIA = 82,
	LICENCIATURA = 81
}
export enum ETipoAcuerdoRvoe {
	FEDERAL = 1,
	ESTADAL = 2
}
